var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _g, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h640v480h-640z",
    fill: "#aa151b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 120h640v240h-640z",
    fill: "#f1bf00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m127.3 213.3-.8-.1-1-1-.7-.4-.6-.8s-.7-1.1-.4-2 .9-1.2 1.4-1.5a12 12 0 0 1 1.5-.5l1-.4 1.3-.3.5-.3c.2 0 .7 0 1-.2l1-.2 1.6.1h4.8c.4 0 1.2.3 1.4.4a35 35 0 0 0 2 .7c.5.1 1.6.3 2.2.6.5.3.9.7 1.1 1l.5 1v1.1l-.5.8-.6 1-.8.6s-.5.5-1 .4c-.4 0-4.8-.8-7.6-.8s-7.3.9-7.3.9",
    fill: "#ad1519"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m127.3 213.3-.8-.1-1-1-.7-.4-.6-.8s-.7-1.1-.4-2 .9-1.2 1.4-1.5a12 12 0 0 1 1.5-.5l1-.4 1.3-.3.5-.3c.2 0 .7 0 1-.2l1-.2 1.6.1h4.8c.4 0 1.2.3 1.4.4a35 35 0 0 0 2 .7c.5.1 1.6.3 2.2.6.5.3.9.7 1.1 1l.5 1v1.1l-.5.8-.6 1-.8.6s-.5.5-1 .4c-.4 0-4.8-.8-7.6-.8s-7.3.9-7.3.9z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m133.3 207c0-1.3.6-2.3 1.3-2.3.8 0 1.4 1 1.4 2.4 0 1.3-.6 2.4-1.4 2.4s-1.3-1.1-1.3-2.5",
    fill: "#c8b100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m133.3 207c0-1.3.6-2.3 1.3-2.3.8 0 1.4 1 1.4 2.4 0 1.3-.6 2.4-1.4 2.4s-1.3-1.1-1.3-2.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m134 207c0-1.2.3-2.1.7-2.1.3 0 .6 1 .6 2.1 0 1.3-.3 2.2-.6 2.2-.4 0-.6-1-.6-2.2",
    fill: "#c8b100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m134 207c0-1.2.3-2.1.7-2.1.3 0 .6 1 .6 2.1 0 1.3-.3 2.2-.6 2.2-.4 0-.6-1-.6-2.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m133.8 204.5c0-.4.4-.8.8-.8s1 .4 1 .8c0 .5-.5.9-1 .9s-.8-.4-.8-.9",
    fill: "#c8b100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m135.3 204.2v.6h-1.4v-.6h.5v-1.2h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2z",
    fill: "#c8b100"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m135.3 204.2v.6h-1.4v-.6h.5v-1.2h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m135.9 204.2v.6h-2.5v-.6h1v-1.2h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2z",
    fill: "#c8b100"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m135.9 204.2v.6h-2.5v-.6h1v-1.2h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m134.9 203.7c.4.1.6.4.6.8 0 .5-.4.9-.8.9s-1-.4-1-.9c0-.4.3-.7.7-.8",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m134.7 213.2h-4.7v-1.1l-.3-1.2-.2-1.5c-1.3-1.7-2.5-2.8-2.9-2.5.1-.3.2-.6.5-.7 1.1-.7 3.5 1 5.2 3.6l.5.7h3.8l.4-.7c1.8-2.7 4.1-4.3 5.2-3.6.3.1.4.4.5.7-.4-.3-1.6.8-2.9 2.5l-.2 1.5-.2 1.2-.1 1.1h-4.7",
    fill: "#c8b100"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m134.7 213.2h-4.7v-1.1l-.3-1.2-.2-1.5c-1.3-1.7-2.5-2.8-2.9-2.5.1-.3.2-.6.5-.7 1.1-.7 3.5 1 5.2 3.6l.5.7h3.8l.4-.7c1.8-2.7 4.1-4.3 5.2-3.6.3.1.4.4.5.7-.4-.3-1.6.8-2.9 2.5l-.2 1.5-.2 1.2-.1 1.1h-4.7z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m126.8 206.8c1-.5 3 1.1 4.6 3.6m11-3.6c-.8-.5-2.8 1.1-4.5 3.6",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m127.8 215.3-.5-1a27.3 27.3 0 0 1 14.7 0l-.5.8a5.7 5.7 0 0 0 -.3.8 22.9 22.9 0 0 0 -6.6-.8c-2.6 0-5.2.3-6.5.8z",
    fill: "#c8b100"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m127.8 215.3-.5-1a27.3 27.3 0 0 1 14.7 0l-.5.8a5.7 5.7 0 0 0 -.3.8 22.9 22.9 0 0 0 -6.6-.8c-2.6 0-5.2.3-6.5.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m134.6 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4-1.4-.5-4-.8-6.5-.8s-5 .3-6.4.8c-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6",
    fill: "#c8b100"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m134.6 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4-1.4-.5-4-.8-6.5-.8s-5 .3-6.4.8c-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m142.1 213.2-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.4.6-1.1.7-1.4-.6-1.4-.6-.5.7-1 1c-.5 0-1.2-.4-1.2-.4l-.2.5-.3.1.2.5a27 27 0 0 1 7.2-.9c3 0 5.5.4 7.4 1l.2-.6",
    fill: "#c8b100"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m142.1 213.2-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.4.6-1.1.7-1.4-.6-1.4-.6-.5.7-1 1c-.5 0-1.2-.4-1.2-.4l-.2.5-.3.1.2.5a27 27 0 0 1 7.2-.9c3 0 5.5.4 7.4 1l.2-.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m134.7 210.7h.2a1 1 0 0 0 0 .4c0 .6.4 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1v-.1l.4-.4.2.5a.9.9 0 0 0 -.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4l.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6-.2.2-.4.2-.7.2-.6 0-1.2-.3-1.4-.8-.3.3-.7.5-1.1.5a1.6 1.6 0 0 1 -1.2-.6 1.6 1.6 0 0 1 -1 .4 1.6 1.6 0 0 1 -1.3-.6 1.6 1.6 0 0 1 -2.4.2 1.6 1.6 0 0 1 -1.2.6 1.5 1.5 0 0 1 -1.1-.5c-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6s-.6 0-.9-.2l-1-1 .1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 .9.9 0 0 0 0-.4v-.5l.4.4a.7.7 0 0 0 0 .1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.7 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.3",
    fill: "#c8b100"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m134.7 210.7h.2a1 1 0 0 0 0 .4c0 .6.4 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1v-.1l.4-.4.2.5a.9.9 0 0 0 -.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4l.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6-.2.2-.4.2-.7.2-.6 0-1.2-.3-1.4-.8-.3.3-.7.5-1.1.5a1.6 1.6 0 0 1 -1.2-.6 1.6 1.6 0 0 1 -1 .4 1.6 1.6 0 0 1 -1.3-.6 1.6 1.6 0 0 1 -2.4.2 1.6 1.6 0 0 1 -1.2.6 1.5 1.5 0 0 1 -1.1-.5c-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6s-.6 0-.9-.2l-1-1 .1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 .9.9 0 0 0 0-.4v-.5l.4.4a.7.7 0 0 0 0 .1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.7 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m134.6 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3a27 27 0 0 1 7.5-1c3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27.3 27.3 0 0 0 -7.4-1",
    fill: "#c8b100"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m134.6 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3a27 27 0 0 1 7.5-1c3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27.3 27.3 0 0 0 -7.4-1z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m131.8 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4c0 .2-.2.4-.4.4a.4.4 0 0 1 -.5-.4",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m131.8 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4c0 .2-.2.4-.4.4a.4.4 0 0 1 -.5-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m134.7 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1 -.3.3h-1",
    fill: "#ad1519"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m134.7 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1 -.3.3h-1",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m130 214.9h-.7c-.1 0-.3 0-.3-.2a.3.3 0 0 1 .2-.3l.7-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1 -.3.4h-.7",
    fill: "#058e6e"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m130 214.9h-.7c-.1 0-.3 0-.3-.2a.3.3 0 0 1 .2-.3l.7-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1 -.3.4h-.7",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m127.3 215.3.3-.4h.7l-.4.6z",
    fill: "#ad1519"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m127.3 215.3.3-.4h.7l-.4.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m136.6 214.4c0-.3.2-.4.4-.4a.4.4 0 0 1 .5.4.4.4 0 0 1 -.5.4.4.4 0 0 1 -.4-.4",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m136.6 214.4c0-.3.2-.4.4-.4a.4.4 0 0 1 .5.4.4.4 0 0 1 -.5.4.4.4 0 0 1 -.4-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m139.3 214.9h.6a.3.3 0 0 0 .4-.2.3.3 0 0 0 -.3-.3l-.6-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7",
    fill: "#058e6e"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m139.3 214.9h.6a.3.3 0 0 0 .4-.2.3.3 0 0 0 -.3-.3l-.6-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m142 215.4-.3-.5h-.7l.3.6.6-.1",
    fill: "#ad1519"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m142 215.4-.3-.5h-.7l.3.6.6-.1",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m134.6 217.1a25 25 0 0 1 -6-.6 25.5 25.5 0 0 1 12.1 0c-1.6.4-3.7.6-6 .6",
    fill: "#ad1519"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m134.6 217.1a25 25 0 0 1 -6-.6 25.5 25.5 0 0 1 12.1 0c-1.6.4-3.7.6-6 .6z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m142 212-.1-.3c-.2 0-.3 0-.4.2 0 .2 0 .4.2.4 0 0 .2 0 .3-.3",
    fill: "#c8b100"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m142 212-.1-.3c-.2 0-.3 0-.4.2 0 .2 0 .4.2.4 0 0 .2 0 .3-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m137.3 211.2c0-.2 0-.4-.2-.4 0 0-.2.1-.2.3s0 .4.2.4l.3-.3",
    fill: "#c8b100"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m137.3 211.2c0-.2 0-.4-.2-.4 0 0-.2.1-.2.3s0 .4.2.4l.3-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m132 211.2.1-.4c.2 0 .3.1.3.3s0 .4-.2.4z",
    fill: "#c8b100"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m132 211.2.1-.4c.2 0 .3.1.3.3s0 .4-.2.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m127.3 212 .1-.3c.2 0 .3 0 .4.2 0 .2 0 .4-.2.4 0 0-.2 0-.3-.3",
    fill: "#c8b100"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m127.3 212 .1-.3c.2 0 .3 0 .4.2 0 .2 0 .4-.2.4 0 0-.2 0-.3-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m134.6 208.5-.8.5.6 1.3.2.1.2-.1.7-1.3z",
    fill: "#c8b100"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m134.6 208.5-.8.5.6 1.3.2.1.2-.1.7-1.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m132.8 210.5.4.5 1.3-.4.1-.2-.1-.2-1.3-.3z",
    fill: "#c8b100"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m132.8 210.5.4.5 1.3-.4.1-.2-.1-.2-1.3-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m136.4 210.5-.3.5-1.3-.4-.2-.2.2-.2 1.3-.3z",
    fill: "#c8b100"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m136.4 210.5-.3.5-1.3-.4-.2-.2.2-.2 1.3-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m129.3 209-.7.7.9 1 .2.1.1-.1.3-1.3-.8-.3",
    fill: "#c8b100"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m129.3 209-.7.7.9 1 .2.1.1-.1.3-1.3-.8-.3",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m128 211.2.4.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6",
    fill: "#c8b100"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m128 211.2.4.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m131.5 210.5-.3.6h-1.2l-.2-.2.1-.3 1.2-.6.5.5",
    fill: "#c8b100"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m131.5 210.5-.3.6h-1.2l-.2-.2.1-.3 1.2-.6.5.5",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m126.6 211.4v.6l-1.4.2-.2-.1v-.2l1-.9z",
    fill: "#c8b100"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m126.6 211.4v.6l-1.4.2-.2-.1v-.2l1-.9z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m129.2 210.9c0-.3.2-.5.5-.5s.5.2.5.5a.5.5 0 0 1 -.5.4.5.5 0 0 1 -.5-.4",
    fill: "#c8b100"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m129.2 210.9c0-.3.2-.5.5-.5s.5.2.5.5a.5.5 0 0 1 -.5.4.5.5 0 0 1 -.5-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m140 209 .7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3",
    fill: "#c8b100"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m140 209 .7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m141.4 211.2-.5.5-1.2-.6v-.2l.1-.2 1.3-.1z",
    fill: "#c8b100"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m141.4 211.2-.5.5-1.2-.6v-.2l.1-.2 1.3-.1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m137.8 210.5.3.6h1.3l.2-.2-.1-.3-1.2-.6z",
    fill: "#c8b100"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m137.8 210.5.3.6h1.3l.2-.2-.1-.3-1.2-.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m142.5 211.4.1.6 1.3.2.2-.1v-.2l-1-.9z",
    fill: "#c8b100"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m142.5 211.4.1.6 1.3.2.2-.1v-.2l-1-.9z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m134.2 210.4a.5.5 0 0 1 .4-.4c.3 0 .5.2.5.4a.5.5 0 0 1 -.5.5.5.5 0 0 1 -.4-.5",
    fill: "#c8b100"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m134.2 210.4a.5.5 0 0 1 .4-.4c.3 0 .5.2.5.4a.5.5 0 0 1 -.5.5.5.5 0 0 1 -.4-.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m139.1 210.9c0-.3.3-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.4.5.5 0 0 1 -.5-.4",
    fill: "#c8b100"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m139.1 210.9c0-.3.3-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.4.5.5 0 0 1 -.5-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m124.8 212.2-.6-.7c-.2-.2-.7-.3-.7-.3 0-.1.3-.3.6-.3a.5.5 0 0 1 .4.2v-.2s.3 0 .4.3v1",
    fill: "#c8b100"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m124.8 212.2-.6-.7c-.2-.2-.7-.3-.7-.3 0-.1.3-.3.6-.3a.5.5 0 0 1 .4.2v-.2s.3 0 .4.3v1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m124.8 212c.1-.2.4-.2.5 0 .2.1.3.3.2.5l-.5-.1c-.2-.1-.3-.4-.2-.5",
    fill: "#c8b100"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m124.8 212c.1-.2.4-.2.5 0 .2.1.3.3.2.5l-.5-.1c-.2-.1-.3-.4-.2-.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m144.3 212.2.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0 -.4.2v-.2s-.3 0-.4.3v.7z",
    fill: "#c8b100"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m144.3 212.2.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0 -.4.2v-.2s-.3 0-.4.3v.7z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m144.3 212c0-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5",
    fill: "#c8b100"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m144.3 212c0-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m124 223h21.4v-5.5h-21.4v5.6z",
    fill: "#c8b100"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m124 223h21.4v-5.5h-21.4v5.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m126.2 226.8a1 1 0 0 1 .4 0h16.5a1.4 1.4 0 0 1 -1-1.2c0-.6.5-1.1 1-1.3a1.7 1.7 0 0 1 -.4 0h-16a1.4 1.4 0 0 1 -.5 0c.6.2 1 .7 1 1.3a1.3 1.3 0 0 1 -1 1.2",
    fill: "#c8b100"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m126.2 226.8a1 1 0 0 1 .4 0h16.5a1.4 1.4 0 0 1 -1-1.2c0-.6.5-1.1 1-1.3a1.7 1.7 0 0 1 -.4 0h-16a1.4 1.4 0 0 1 -.5 0c.6.2 1 .7 1 1.3a1.3 1.3 0 0 1 -1 1.2z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m126.6 226.8h16c.6 0 1 .3 1 .7s-.4.8-1 .8h-16c-.5 0-1-.4-1-.8s.5-.8 1-.8",
    fill: "#c8b100"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m126.6 226.8h16c.6 0 1 .3 1 .7s-.4.8-1 .8h-16c-.5 0-1-.4-1-.8s.5-.8 1-.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m126.6 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.5 0-1-.2-1-.6 0-.3.5-.6 1-.6",
    fill: "#c8b100"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m126.6 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.5 0-1-.2-1-.6 0-.3.5-.6 1-.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m149.6 317.4c-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0 -3.8-.8c-1.4 0-2.7.3-3.7.8a8.3 8.3 0 0 1 -3.8.8c-1.5 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0 -3.7-.8 8 8 0 0 0 -3.7.8 8.3 8.3 0 0 1 -3.8.8v2.4c1.5 0 2.8-.4 3.8-.9a8.2 8.2 0 0 1 3.7-.8c1.4 0 2.7.3 3.7.8s2.2.9 3.7.9a8.4 8.4 0 0 0 3.8-.9c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.9 3.7.9z",
    fill: "#005bbf"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m149.6 317.4c-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0 -3.8-.8c-1.4 0-2.7.3-3.7.8a8.3 8.3 0 0 1 -3.8.8c-1.5 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0 -3.7-.8 8 8 0 0 0 -3.7.8 8.3 8.3 0 0 1 -3.8.8v2.4c1.5 0 2.8-.4 3.8-.9a8.2 8.2 0 0 1 3.7-.8c1.4 0 2.7.3 3.7.8s2.2.9 3.7.9a8.4 8.4 0 0 0 3.8-.9c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.9 3.7.9z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m149.6 319.8a8 8 0 0 1 -3.7-.9 8.3 8.3 0 0 0 -3.8-.8c-1.4 0-2.7.3-3.7.8s-2.3.9-3.8.9-2.8-.4-3.7-.9a8.4 8.4 0 0 0 -3.7-.8 8.2 8.2 0 0 0 -3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.4 3.8-.9a8.1 8.1 0 0 1 3.7-.7c1.4 0 2.7.2 3.7.7a8.3 8.3 0 0 0 7.5 0 8.5 8.5 0 0 1 7.5.1 8.1 8.1 0 0 0 3.7.8z",
    fill: "#ccc"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m149.6 319.8a8 8 0 0 1 -3.7-.9 8.3 8.3 0 0 0 -3.8-.8c-1.4 0-2.7.3-3.7.8s-2.3.9-3.8.9-2.8-.4-3.7-.9a8.4 8.4 0 0 0 -3.7-.8 8.2 8.2 0 0 0 -3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.4 3.8-.9a8.1 8.1 0 0 1 3.7-.7c1.4 0 2.7.2 3.7.7a8.3 8.3 0 0 0 7.5 0 8.5 8.5 0 0 1 7.5.1 8.1 8.1 0 0 0 3.7.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m149.6 322a7 7 0 0 1 -3.7-.8 8.3 8.3 0 0 0 -3.8-.7c-1.4 0-2.7.2-3.7.7-1 .6-2.3.9-3.8.9s-2.8-.4-3.7-.9a8.4 8.4 0 0 0 -3.7-.8 8 8 0 0 0 -3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.3 3.8-.9a10.2 10.2 0 0 1 7.4 0 7 7 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.8 3.7.8z",
    fill: "#005bbf"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m149.6 322a7 7 0 0 1 -3.7-.8 8.3 8.3 0 0 0 -3.8-.7c-1.4 0-2.7.2-3.7.7-1 .6-2.3.9-3.8.9s-2.8-.4-3.7-.9a8.4 8.4 0 0 0 -3.7-.8 8 8 0 0 0 -3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.3 3.8-.9a10.2 10.2 0 0 1 7.4 0 7 7 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.8 3.7.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m149.6 326.7a8 8 0 0 1 -3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0 -3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1 -3.7-.9 8.4 8.4 0 0 0 -3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.9 10.2 10.2 0 0 1 7.4 0 8 8 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.8-.8 1.4 0 2.7.3 3.7.8s2.3.8 3.7.8z",
    fill: "#ccc"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m149.6 326.7a8 8 0 0 1 -3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0 -3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1 -3.7-.9 8.4 8.4 0 0 0 -3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.9 10.2 10.2 0 0 1 7.4 0 8 8 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.8-.8 1.4 0 2.7.3 3.7.8s2.3.8 3.7.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m149.6 329a8.1 8.1 0 0 1 -3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0 -3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1 -3.7-.9 8.4 8.4 0 0 0 -3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8s2.7.3 3.7.7a8.4 8.4 0 0 0 7.5 0c1-.4 2.3-.7 3.8-.7 1.4 0 2.7.3 3.7.8s2.2.8 3.7.8z",
    fill: "#005bbf"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m149.6 329a8.1 8.1 0 0 1 -3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0 -3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1 -3.7-.9 8.4 8.4 0 0 0 -3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8s2.7.3 3.7.7a8.4 8.4 0 0 0 7.5 0c1-.4 2.3-.7 3.8-.7 1.4 0 2.7.3 3.7.8s2.2.8 3.7.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m126.2 308 .2.5c0 1.5-1.3 2.6-2.7 2.6h22a2.7 2.7 0 0 1 -2.7-2.6v-.5a1.3 1.3 0 0 1 -.3 0h-16a1.4 1.4 0 0 1 -.5 0",
    fill: "#c8b100"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m126.2 308 .2.5c0 1.5-1.3 2.6-2.7 2.6h22a2.7 2.7 0 0 1 -2.7-2.6v-.5a1.3 1.3 0 0 1 -.3 0h-16a1.4 1.4 0 0 1 -.5 0z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m126.6 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.5 0-1-.3-1-.8 0-.4.5-.7 1-.7",
    fill: "#c8b100"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m126.6 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.5 0-1-.3-1-.8 0-.4.5-.7 1-.7z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m123.7 316.7h22v-5.7h-22v5.6z",
    fill: "#c8b100"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m123.7 316.7h22v-5.7h-22v5.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m122 286.7c-2.2 1.2-3.7 2.5-3.4 3.2 0 .6.8 1 1.8 1.6 1.5 1.1 2.5 3 1.7 4a5.5 5.5 0 0 0 -.1-8.8",
    fill: "#ad1519"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m122 286.7c-2.2 1.2-3.7 2.5-3.4 3.2 0 .6.8 1 1.8 1.6 1.5 1.1 2.5 3 1.7 4a5.5 5.5 0 0 0 -.1-8.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m126.8 305.6h15.6v-76.6h-15.6v76.5z",
    fill: "#ccc"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m138 229.2v76.3m1.7-76.3v76.3m-12.9 0h15.6v-76.4h-15.6v76.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m158.4 257.7a49.6 49.6 0 0 0 -23.3-2c-9.4 1.6-16.5 5.3-15.9 8.4v.2l-3.5-8.2c-.6-3.3 7.2-7.5 17.6-9.2a43 43 0 0 1 9.2-.7c6.6 0 12.4.8 15.8 2.1v9.4",
    fill: "#ad1519"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m158.4 257.7a49.6 49.6 0 0 0 -23.3-2c-9.4 1.6-16.5 5.3-15.9 8.4v.2l-3.5-8.2c-.6-3.3 7.2-7.5 17.6-9.2a43 43 0 0 1 9.2-.7c6.6 0 12.4.8 15.8 2.1v9.4",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m126.8 267.3c-4.3-.3-7.3-1.4-7.6-3.2-.3-1.5 1.2-3 3.8-4.5 1.2.1 2.5.3 3.8.3z",
    fill: "#ad1519"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m126.8 267.3c-4.3-.3-7.3-1.4-7.6-3.2-.3-1.5 1.2-3 3.8-4.5 1.2.1 2.5.3 3.8.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m142.5 261.5c2.7.4 4.7 1 5.7 1.9l.1.2c.5 1-1.9 3-5.9 5.4v-7.5",
    fill: "#ad1519"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m142.5 261.5c2.7.4 4.7 1 5.7 1.9l.1.2c.5 1-1.9 3-5.9 5.4v-7.5",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m117.1 282c-.4-1.2 3.8-3.6 9.8-5.8l7.8-3.2c8.3-3.7 14.4-7.9 13.6-9.4v-.2c.4.4 1 8 1 8 .8 1.3-4.8 5.5-12.4 9.1-2.5 1.2-7.6 3-10 4-4.4 1.4-8.7 4.3-8.3 5.3l-1.5-7.7",
    fill: "#ad1519"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m117.1 282c-.4-1.2 3.8-3.6 9.8-5.8l7.8-3.2c8.3-3.7 14.4-7.9 13.6-9.4v-.2c.4.4 1 8 1 8 .8 1.3-4.8 5.5-12.4 9.1-2.5 1.2-7.6 3-10 4-4.4 1.4-8.7 4.3-8.3 5.3l-1.5-7.7z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m125.8 254c1.9-.6 3.1-1.5 2.5-3-.4-1-1.4-1-2.8-.6l-2.6 1 2.3 5.8.8-.3.8-.3-1-2.5zm-1.2-2.7.7-.3c.5-.2 1.2.1 1.4.8.2.5.2 1-.5 1.5a4.4 4.4 0 0 1 -.6.3zm7.3-2.5-.9.3h-.8l1.3 6.1 4.3-.8-.2-.4v-.4l-2.5.6-1.2-5.3m8.4 5.2c.8-2.2 1.7-4.3 2.7-6.4a5.3 5.3 0 0 1 -1 0 54.8 54.8 0 0 1 -1.8 4.6l-2.4-4.3-1 .1h-1a131.4 131.4 0 0 1 3.5 6zm8.8-4.7.4-.9a3.4 3.4 0 0 0 -1.7-.6c-1.7-.1-2.7.6-2.8 1.7-.2 2.1 3.2 2 3 3.4 0 .6-.7.9-1.4.8-.8 0-1.4-.5-1.4-1.2h-.3a7.3 7.3 0 0 1 -.4 1.1 4 4 0 0 0 1.8.6c1.7.2 3-.5 3.2-1.7.2-2-3.3-2.1-3.1-3.4 0-.5.4-.8 1.3-.7.7 0 1 .4 1.2.9z",
    fill: "#c8b100"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m277.9 211.6s-.7.8-1.3.9c-.5 0-1.1-.5-1.1-.5s-.5.5-1 .6c-.6.1-1.4-.6-1.4-.6l-1 1c-.6 0-1.1-.3-1.1-.3s-.3.4-.7.6h-.4l-.6-.4-.7-.7-.5-.3-.4-1v-.5c-.1-.6.8-1.4 2.2-1.7a3.9 3.9 0 0 1 2 0c.5-.5 1.7-.8 3-.8s2.4.3 3 .7a5.5 5.5 0 0 1 2.9-.7c1.3 0 2.5.3 3 .8.5-.2 1.2-.2 2 0 1.4.3 2.3 1 2.2 1.7v.5l-.4 1-.6.3-.6.7-.6.3s-.3.2-.4 0c-.4-.1-.7-.5-.7-.5s-.6.4-1 .2c-.5-.2-1-1-1-1s-.9.8-1.4.7c-.6-.1-1-.6-1-.6s-.7.6-1.2.5-1.2-.9-1.2-.9",
    fill: "#ad1519"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m277.9 211.6s-.7.8-1.3.9c-.5 0-1.1-.5-1.1-.5s-.5.5-1 .6c-.6.1-1.4-.6-1.4-.6l-1 1c-.6 0-1.1-.3-1.1-.3s-.3.4-.7.6h-.4l-.6-.4-.7-.7-.5-.3-.4-1v-.5c-.1-.6.8-1.4 2.2-1.7a3.9 3.9 0 0 1 2 0c.5-.5 1.7-.8 3-.8s2.4.3 3 .7a5.5 5.5 0 0 1 2.9-.7c1.3 0 2.5.3 3 .8.5-.2 1.2-.2 2 0 1.4.3 2.3 1 2.2 1.7v.5l-.4 1-.6.3-.6.7-.6.3s-.3.2-.4 0c-.4-.1-.7-.5-.7-.5s-.6.4-1 .2c-.5-.2-1-1-1-1s-.9.8-1.4.7c-.6-.1-1-.6-1-.6s-.7.6-1.2.5-1.2-.9-1.2-.9z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m276.5 207.6c0-1 .6-2 1.3-2 .8 0 1.3 1 1.3 2s-.5 1.8-1.3 1.8c-.7 0-1.3-.8-1.3-1.9",
    fill: "#c8b100"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m276.5 207.6c0-1 .6-2 1.3-2 .8 0 1.3 1 1.3 2s-.5 1.8-1.3 1.8c-.7 0-1.3-.8-1.3-1.9z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m277.3 207.6c0-1 .2-1.8.5-1.8.4 0 .7.8.7 1.8s-.3 1.7-.6 1.7c-.4 0-.6-.8-.6-1.8",
    fill: "#c8b100"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "m277.3 207.6c0-1 .2-1.8.5-1.8.4 0 .7.8.7 1.8s-.3 1.7-.6 1.7c-.4 0-.6-.8-.6-1.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m271 215.3a4.5 4.5 0 0 0 -.5-1 27.4 27.4 0 0 1 14.8 0l-.6.8a5.2 5.2 0 0 0 -.3.8 22.9 22.9 0 0 0 -6.6-.8c-2.6 0-5.2.3-6.6.8z",
    fill: "#c8b100"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "m271 215.3a4.5 4.5 0 0 0 -.5-1 27.4 27.4 0 0 1 14.8 0l-.6.8a5.2 5.2 0 0 0 -.3.8 22.9 22.9 0 0 0 -6.6-.8c-2.6 0-5.2.3-6.6.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m277.8 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4a24.1 24.1 0 0 0 -6.5-.8c-2.5 0-5 .3-6.4.8-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6",
    fill: "#c8b100"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m277.8 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4a24.1 24.1 0 0 0 -6.5-.8c-2.5 0-5 .3-6.4.8-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "m283.5 208.4c0-.2.2-.4.4-.4s.5.2.5.4-.2.4-.5.4a.4.4 0 0 1 -.4-.4",
    fill: "#fff"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m283.5 208.4c0-.2.2-.4.4-.4s.5.2.5.4-.2.4-.5.4a.4.4 0 0 1 -.4-.4zm-.2-1.4a.4.4 0 0 1 .4-.4c.2 0 .4.1.4.4s-.2.4-.4.4a.4.4 0 0 1 -.4-.4zm-1.1-1c0-.2.2-.3.4-.3s.4.1.4.4c0 .2-.2.4-.4.4a.4.4 0 0 1 -.4-.5zm-1.4-.4c0-.2.2-.4.4-.4.3 0 .5.2.5.4s-.2.4-.4.4-.5-.2-.5-.4zm-1.4 0c0-.2.2-.3.5-.3s.4.1.4.4c0 .2-.2.4-.4.4a.4.4 0 0 1 -.5-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m287.8 211.2.2-1a2.7 2.7 0 0 0 -2.7-2.8c-.5 0-1 .1-1.3.3",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m283 209.2.2-.8c0-1.1-1.1-2-2.5-2-.6 0-1.2.2-1.6.4",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m288.2 210c0-.3.2-.5.4-.5s.4.2.4.4c0 .3-.2.4-.4.4s-.4-.1-.4-.4zm-.2-1.6c0-.2.2-.4.4-.4a.4.4 0 0 1 .5.4c0 .2-.2.4-.4.4-.3 0-.5-.2-.5-.4zm-1-1.1a.4.4 0 0 1 .5-.4c.2 0 .4.1.4.4a.4.4 0 0 1 -.4.4.4.4 0 0 1 -.5-.4zm-1.3-.7c0-.2.2-.4.5-.4s.4.2.4.4c0 .3-.2.5-.4.5a.4.4 0 0 1 -.5-.5zm-1.4.1c0-.2.2-.4.5-.4s.4.2.4.4-.2.4-.4.4-.5-.2-.5-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "m285.3 213.2-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.3.6-1.1.7-1.4-.6-1.4-.6-.4.7-1 1c-.5 0-1.2-.4-1.2-.4l-.1.5-.3.1.1.5a27 27 0 0 1 7.3-.9c2.8 0 5.4.4 7.3 1l.2-.6",
    fill: "#c8b100"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m285.3 213.2-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.3.6-1.1.7-1.4-.6-1.4-.6-.4.7-1 1c-.5 0-1.2-.4-1.2-.4l-.1.5-.3.1.1.5a27 27 0 0 1 7.3-.9c2.8 0 5.4.4 7.3 1l.2-.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m271.3 208.4c0-.2.2-.4.4-.4s.4.2.4.4a.4.4 0 0 1 -.4.4.4.4 0 0 1 -.4-.4",
    fill: "#fff"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m271.3 208.4c0-.2.2-.4.4-.4s.4.2.4.4a.4.4 0 0 1 -.4.4.4.4 0 0 1 -.4-.4zm.2-1.4c0-.3.2-.4.4-.4s.5.1.5.4-.2.4-.5.4a.4.4 0 0 1 -.4-.4zm1-1c0-.2.3-.3.5-.3s.5.1.5.4c0 .2-.2.4-.5.4a.4.4 0 0 1 -.4-.5zm1.4-.4c0-.2.2-.4.5-.4s.4.2.4.4-.2.4-.4.4-.5-.2-.5-.4zm1.4 0c0-.2.2-.3.5-.3.2 0 .4.1.4.4 0 .2-.2.4-.4.4a.4.4 0 0 1 -.5-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "m267.8 211.2a2.8 2.8 0 0 1 -.2-1 2.7 2.7 0 0 1 2.7-2.8c.5 0 1 .1 1.4.3",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m272.7 209.2a1.7 1.7 0 0 1 -.3-.8c0-1 1.2-2 2.6-2a3 3 0 0 1 1.5.4",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m266.6 210c0-.3.2-.5.4-.5.3 0 .4.2.4.4a.4.4 0 0 1 -.4.4c-.2 0-.4-.1-.4-.4zm.1-1.6c0-.2.3-.4.5-.4s.4.2.4.4-.2.4-.4.4-.4-.2-.4-.4zm1-1.1c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1 -.4.4.4.4 0 0 1 -.5-.4zm1.3-.7c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.4.4 0 0 1 -.5-.5zm1.4.1c0-.2.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1 -.4.4c-.3 0-.5-.2-.5-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m277.9 210.7h.2a1 1 0 0 0 0 .4c0 .6.5 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1a.7.7 0 0 0 0-.1l.4-.4.2.5a1 1 0 0 0 -.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4s.7-.7.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6a1.5 1.5 0 0 1 -.7.2c-.6 0-1.2-.3-1.4-.8a1.5 1.5 0 0 1 -1.1.5c-.5 0-1-.2-1.2-.6a1.5 1.5 0 0 1 -1 .4c-.6 0-1-.2-1.4-.6-.2.4-.7.6-1.2.6-.4 0-.8-.1-1-.4a1.6 1.6 0 0 1 -1.3.6c-.4 0-.8-.2-1.1-.5-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6s-.6 0-.9-.2a4.2 4.2 0 0 1 -1-1l.1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 1 1 0 0 0 0-.4v-.5l.4.4v.1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.6 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.2",
    fill: "#c8b100"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m277.9 210.7h.2a1 1 0 0 0 0 .4c0 .6.5 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1a.7.7 0 0 0 0-.1l.4-.4.2.5a1 1 0 0 0 -.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4s.7-.7.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6a1.5 1.5 0 0 1 -.7.2c-.6 0-1.2-.3-1.4-.8a1.5 1.5 0 0 1 -1.1.5c-.5 0-1-.2-1.2-.6a1.5 1.5 0 0 1 -1 .4c-.6 0-1-.2-1.4-.6-.2.4-.7.6-1.2.6-.4 0-.8-.1-1-.4a1.6 1.6 0 0 1 -1.3.6c-.4 0-.8-.2-1.1-.5-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6s-.6 0-.9-.2a4.2 4.2 0 0 1 -1-1l.1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 1 1 0 0 0 0-.4v-.5l.4.4v.1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.6 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "m277.8 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3c2-.6 4.6-1 7.5-1 3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27 27 0 0 0 -7.4-1",
    fill: "#c8b100"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m277.8 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3c2-.6 4.6-1 7.5-1 3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27 27 0 0 0 -7.4-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m275 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1 -.4.4c-.3 0-.5-.2-.5-.4",
    fill: "#fff"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "m275 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1 -.4.4c-.3 0-.5-.2-.5-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "m277.9 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1 -.3.3h-1",
    fill: "#ad1519"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "m277.9 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1 -.3.3h-1",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "m273.2 214.9h-.6a.3.3 0 0 1 -.4-.2.3.3 0 0 1 .3-.3l.6-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1 -.3.4h-.7",
    fill: "#058e6e"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "m273.2 214.9h-.6a.3.3 0 0 1 -.4-.2.3.3 0 0 1 .3-.3l.6-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1 -.3.4h-.7",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "m270.5 215.3.3-.4h.7l-.4.6z",
    fill: "#ad1519"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "m270.5 215.3.3-.4h.7l-.4.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "m279.8 214.4c0-.3.2-.4.4-.4.3 0 .5.1.5.4 0 .2-.2.4-.5.4a.4.4 0 0 1 -.4-.4",
    fill: "#fff"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "m279.8 214.4c0-.3.2-.4.4-.4.3 0 .5.1.5.4 0 .2-.2.4-.5.4a.4.4 0 0 1 -.4-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "m282.5 214.9h.7a.3.3 0 0 0 .3-.2.3.3 0 0 0 -.2-.3l-.7-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7",
    fill: "#058e6e"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "m282.5 214.9h.7a.3.3 0 0 0 .3-.2.3.3 0 0 0 -.2-.3l-.7-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "m285.1 215.4-.2-.5h-.7l.3.6z",
    fill: "#ad1519"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "m285.1 215.4-.2-.5h-.7l.3.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "m277.8 217.1a25 25 0 0 1 -6-.6 25.4 25.4 0 0 1 6-.7c2.4 0 4.5.3 6.1.7-1.6.4-3.7.6-6 .6",
    fill: "#ad1519"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "m277.8 217.1a25 25 0 0 1 -6-.6 25.4 25.4 0 0 1 6-.7c2.4 0 4.5.3 6.1.7-1.6.4-3.7.6-6 .6z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "m285.2 212-.1-.3c-.2 0-.3 0-.4.2l.1.4c.2 0 .3 0 .4-.3",
    fill: "#c8b100"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "m285.2 212-.1-.3c-.2 0-.3 0-.4.2l.1.4c.2 0 .3 0 .4-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "m280.6 211.2c0-.2-.1-.4-.3-.4 0 0-.2.1-.2.3s0 .4.2.4z",
    fill: "#c8b100"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "m280.6 211.2c0-.2-.1-.4-.3-.4 0 0-.2.1-.2.3s0 .4.2.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "m275.2 211.2c0-.2 0-.4.2-.4l.3.3-.2.4c-.2 0-.3-.2-.3-.3",
    fill: "#c8b100"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "m275.2 211.2c0-.2 0-.4.2-.4l.3.3-.2.4c-.2 0-.3-.2-.3-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "m270.5 212 .1-.3c.2 0 .3 0 .4.2l-.1.4c-.2 0-.3 0-.4-.3",
    fill: "#c8b100"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "m270.5 212 .1-.3c.2 0 .3 0 .4.2l-.1.4c-.2 0-.3 0-.4-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "m277.8 208.5-.8.5.6 1.3.2.1.3-.1.6-1.3z",
    fill: "#c8b100"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "m277.8 208.5-.8.5.6 1.3.2.1.3-.1.6-1.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "m276 210.5.4.5 1.3-.4.1-.2-.1-.2-1.3-.3z",
    fill: "#c8b100"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "m276 210.5.4.5 1.3-.4.1-.2-.1-.2-1.3-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "m279.6 210.5-.3.5-1.3-.4-.1-.2v-.2l1.4-.3.4.6",
    fill: "#c8b100"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m279.6 210.5-.3.5-1.3-.4-.1-.2v-.2l1.4-.3.4.6",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "m272.5 209-.7.7.9 1 .2.1.2-.1.2-1.3-.8-.3",
    fill: "#c8b100"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m272.5 209-.7.7.9 1 .2.1.2-.1.2-1.3-.8-.3",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "m271.1 211.2.5.5 1.2-.6v-.2l-.1-.2-1.3-.1z",
    fill: "#c8b100"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m271.1 211.2.5.5 1.2-.6v-.2l-.1-.2-1.3-.1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "m274.7 210.5-.3.6h-1.3l-.2-.2.1-.3 1.2-.6z",
    fill: "#c8b100"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "m274.7 210.5-.3.6h-1.3l-.2-.2.1-.3 1.2-.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "m269.8 211.4v.6l-1.4.2-.2-.1v-.2l1-.9z",
    fill: "#c8b100"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "m269.8 211.4v.6l-1.4.2-.2-.1v-.2l1-.9z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "m272.4 210.9c0-.3.2-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.4.5.5 0 0 1 -.5-.4",
    fill: "#c8b100"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m272.4 210.9c0-.3.2-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.4.5.5 0 0 1 -.5-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m283.2 209 .7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3",
    fill: "#c8b100"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "m283.2 209 .7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "m284.6 211.2-.5.5-1.2-.6v-.2l.1-.2 1.3-.1z",
    fill: "#c8b100"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m284.6 211.2-.5.5-1.2-.6v-.2l.1-.2 1.3-.1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "m281 210.5.3.6h1.3l.2-.2-.1-.3-1.2-.6z",
    fill: "#c8b100"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "m281 210.5.3.6h1.3l.2-.2-.1-.3-1.2-.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m285.7 211.4v.6l1.4.2.2-.1v-.2l-1-.9z",
    fill: "#c8b100"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "m285.7 211.4v.6l1.4.2.2-.1v-.2l-1-.9z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "m277.4 210.4c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.5.5 0 0 1 -.5-.5",
    fill: "#c8b100"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "m277.4 210.4c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.5.5 0 0 1 -.5-.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "m282.3 210.9c0-.3.3-.5.5-.5.3 0 .5.2.5.5s-.2.4-.5.4a.5.5 0 0 1 -.5-.4",
    fill: "#c8b100"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "m282.3 210.9c0-.3.3-.5.5-.5.3 0 .5.2.5.5s-.2.4-.5.4a.5.5 0 0 1 -.5-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "m277 205.4c0-.5.4-.8.8-.8s1 .3 1 .8-.5.8-1 .8a.9.9 0 0 1 -.8-.8",
    fill: "#c8b100"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "m278.5 205.1v.6h-1.5v-.6h.4v-1.3h-.5v-.5h.5v-.6h.6v.6h.6v.6h-.6v1.2h.4",
    fill: "#c8b100"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "m278.5 205.1v.6h-1.5v-.6h.4v-1.3h-.5v-.5h.5v-.6h.6v.6h.6v.6h-.6v1.2h.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "m279 205.1v.6h-2.4v-.6h1v-1.3h-.7v-.5h.6v-.6h.6v.6h.6v.6h-.6v1.2h1",
    fill: "#c8b100"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "m278.1 204.6c.4 0 .6.4.6.8 0 .5-.4.8-.9.8a.9.9 0 0 1 -.8-.8c0-.4.2-.7.6-.8",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "m268 212.2-.6-.7a2.3 2.3 0 0 0 -.7-.3c0-.1.3-.3.6-.3.2 0 .3 0 .4.2v-.2s.3 0 .4.3v1",
    fill: "#c8b100"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "m268 212.2-.6-.7a2.3 2.3 0 0 0 -.7-.3c0-.1.3-.3.6-.3.2 0 .3 0 .4.2v-.2s.3 0 .4.3v1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m268 212c.1-.2.4-.2.5 0 .2.1.3.3.1.5l-.5-.1c-.1-.1-.2-.4 0-.5",
    fill: "#c8b100"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "m268 212c.1-.2.4-.2.5 0 .2.1.3.3.1.5l-.5-.1c-.1-.1-.2-.4 0-.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "m287.5 212.2.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0 -.4.2v-.2s-.3 0-.4.3v.7z",
    fill: "#c8b100"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "m287.5 212.2.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0 -.4.2v-.2s-.3 0-.4.3v.7z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "m287.5 212c-.1-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5",
    fill: "#c8b100"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "m287.5 212c-.1-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "m267.2 223h21.4v-5.5h-21.4v5.6z",
    fill: "#c8b100"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "m267.2 223h21.4v-5.5h-21.4v5.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "m286.3 226.8a1 1 0 0 0 -.4 0h-16.5c.6-.2 1-.7 1-1.2 0-.6-.4-1.1-1-1.3h17-.1c-.6.2-1 .7-1 1.3 0 .5.4 1 1 1.2",
    fill: "#c8b100"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "m286.3 226.8a1 1 0 0 0 -.4 0h-16.5c.6-.2 1-.7 1-1.2 0-.6-.4-1.1-1-1.3h17-.1c-.6.2-1 .7-1 1.3 0 .5.4 1 1 1.2z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "m269.9 226.8h16c.6 0 1 .3 1 .7s-.4.8-1 .8h-16c-.6 0-1-.4-1-.8s.5-.8 1-.8",
    fill: "#c8b100"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "m269.9 226.8h16c.6 0 1 .3 1 .7s-.4.8-1 .8h-16c-.6 0-1-.4-1-.8s.5-.8 1-.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "m269.9 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.6 0-1-.2-1-.6 0-.3.4-.6 1-.6",
    fill: "#c8b100"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "m269.9 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.6 0-1-.2-1-.6 0-.3.4-.6 1-.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "m263 317.4c1.4 0 2.7-.3 3.7-.8a8.4 8.4 0 0 1 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.8a8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.8 3.8.8v2.4a8.3 8.3 0 0 1 -3.8-.9 8.2 8.2 0 0 0 -3.7-.8c-1.4 0-2.7.3-3.6.8-1 .5-2.3.9-3.8.9a8 8 0 0 1 -3.7-.9 8.4 8.4 0 0 0 -3.8-.8 8.3 8.3 0 0 0 -3.7.8c-1 .5-2.3.9-3.8.9v-2.4",
    fill: "#005bbf"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "m263 317.4c1.4 0 2.7-.3 3.7-.8a8.4 8.4 0 0 1 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.8a8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.8 3.8.8v2.4a8.3 8.3 0 0 1 -3.8-.9 8.2 8.2 0 0 0 -3.7-.8c-1.4 0-2.7.3-3.6.8-1 .5-2.3.9-3.8.9a8 8 0 0 1 -3.7-.9 8.4 8.4 0 0 0 -3.8-.8 8.3 8.3 0 0 0 -3.7.8c-1 .5-2.3.9-3.8.9v-2.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "m263 319.8c1.4 0 2.7-.4 3.7-.9s2.3-.8 3.7-.8 2.8.3 3.8.8 2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8c1.5 0 2.8.3 3.7.8 1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1 -3.8-.9 8.1 8.1 0 0 0 -3.7-.7c-1.4 0-2.7.2-3.6.7-1 .5-2.3.9-3.8.9a7 7 0 0 1 -3.7-.9c-1-.4-2.3-.7-3.8-.7a8.3 8.3 0 0 0 -3.7.7 8.1 8.1 0 0 1 -3.8.9v-2.3",
    fill: "#ccc"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "m263 319.8c1.4 0 2.7-.4 3.7-.9s2.3-.8 3.7-.8 2.8.3 3.8.8 2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8c1.5 0 2.8.3 3.7.8 1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1 -3.8-.9 8.1 8.1 0 0 0 -3.7-.7c-1.4 0-2.7.2-3.6.7-1 .5-2.3.9-3.8.9a7 7 0 0 1 -3.7-.9c-1-.4-2.3-.7-3.8-.7a8.3 8.3 0 0 0 -3.7.7 8.1 8.1 0 0 1 -3.8.9v-2.3",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "m263 322c1.4 0 2.7-.2 3.7-.8 1-.4 2.3-.7 3.7-.7s2.8.2 3.8.7 2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1 -3.8-.9 8.2 8.2 0 0 0 -3.7-.7c-1.4 0-2.7.3-3.6.7-1 .6-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0 -3.8-.8 8.3 8.3 0 0 0 -3.7.8c-1 .5-2.3.8-3.8.8v-2.4",
    fill: "#005bbf"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "m263 322c1.4 0 2.7-.2 3.7-.8 1-.4 2.3-.7 3.7-.7s2.8.2 3.8.7 2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1 -3.8-.9 8.2 8.2 0 0 0 -3.7-.7c-1.4 0-2.7.3-3.6.7-1 .6-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0 -3.8-.8 8.3 8.3 0 0 0 -3.7.8c-1 .5-2.3.8-3.8.8v-2.4",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "m263 326.7a8 8 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8s2.8.3 3.8.8 2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.9a8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8a8.3 8.3 0 0 0 3.8.8v-2.3a8.3 8.3 0 0 1 -3.8-.9 8.2 8.2 0 0 0 -3.7-.7c-1.4 0-2.7.3-3.6.7-1 .5-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0 -3.8-.8 8.3 8.3 0 0 0 -3.7.8c-1 .5-2.3.8-3.8.8v2.3",
    fill: "#ccc"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "m263 326.7a8 8 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8s2.8.3 3.8.8 2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.9a8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8a8.3 8.3 0 0 0 3.8.8v-2.3a8.3 8.3 0 0 1 -3.8-.9 8.2 8.2 0 0 0 -3.7-.7c-1.4 0-2.7.3-3.6.7-1 .5-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0 -3.8-.8 8.3 8.3 0 0 0 -3.7.8c-1 .5-2.3.8-3.8.8v2.3",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "m263 329a8.1 8.1 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8s2.8.3 3.8.8 2.3.8 3.7.8a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8 1 .5 2.4.8 3.8.8v-2.3a8.3 8.3 0 0 1 -3.8-.8 8.2 8.2 0 0 0 -3.7-.8 8.4 8.4 0 0 0 -3.6.7 8.2 8.2 0 0 1 -3.8.9c-1.4 0-2.8-.3-3.7-.8-1-.5-2.3-.8-3.8-.8-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v2.3",
    fill: "#005bbf"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "m263 329a8.1 8.1 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8s2.8.3 3.8.8 2.3.8 3.7.8a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8 1 .5 2.4.8 3.8.8v-2.3a8.3 8.3 0 0 1 -3.8-.8 8.2 8.2 0 0 0 -3.7-.8 8.4 8.4 0 0 0 -3.6.7 8.2 8.2 0 0 1 -3.8.9c-1.4 0-2.8-.3-3.7-.8-1-.5-2.3-.8-3.8-.8-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v2.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "m286.3 308-.1.5c0 1.5 1.2 2.6 2.7 2.6h-22c1.5 0 2.7-1.2 2.7-2.6l-.1-.5z",
    fill: "#c8b100"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "m286.3 308-.1.5c0 1.5 1.2 2.6 2.7 2.6h-22c1.5 0 2.7-1.2 2.7-2.6l-.1-.5z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "m269.9 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.6 0-1-.3-1-.8 0-.4.5-.7 1-.7",
    fill: "#c8b100"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "m269.9 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.6 0-1-.3-1-.8 0-.4.5-.7 1-.7z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "m266.9 316.7h22v-5.7h-22v5.6z",
    fill: "#c8b100"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "m266.9 316.7h22v-5.7h-22v5.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m290.6 286.7c2.1 1.2 3.6 2.5 3.4 3.2-.1.6-.8 1-1.8 1.6-1.6 1.1-2.5 3-1.8 4a5.5 5.5 0 0 1 .2-8.8",
    fill: "#ad1519"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "m290.6 286.7c2.1 1.2 3.6 2.5 3.4 3.2-.1.6-.8 1-1.8 1.6-1.6 1.1-2.5 3-1.8 4a5.5 5.5 0 0 1 .2-8.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m270.1 305.6h15.6v-76.6h-15.6v76.5z",
    fill: "#ccc"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "m281.4 229.1v76.3m1.8-76.3v76.3m-13 .2h15.5v-76.6h-15.6v76.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "m254.2 257.7a49.6 49.6 0 0 1 23.3-2c9.3 1.6 16.4 5.3 15.9 8.4v.2l3.5-8.2c.6-3.3-7.3-7.5-17.6-9.2a53.5 53.5 0 0 0 -9.2-.7c-6.7 0-12.4.8-15.9 2.1z",
    fill: "#ad1519"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "m254.2 257.7a49.6 49.6 0 0 1 23.3-2c9.3 1.6 16.4 5.3 15.9 8.4v.2l3.5-8.2c.6-3.3-7.3-7.5-17.6-9.2a53.5 53.5 0 0 0 -9.2-.7c-6.7 0-12.4.8-15.9 2.1z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "m285.7 267.3c4.4-.3 7.3-1.4 7.7-3.2.2-1.5-1.2-3-3.8-4.5-1.2.1-2.5.3-3.9.3z",
    fill: "#ad1519"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "m285.7 267.3c4.4-.3 7.3-1.4 7.7-3.2.2-1.5-1.2-3-3.8-4.5-1.2.1-2.5.3-3.9.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "m270 261.5a13 13 0 0 0 -5.7 1.9v.2c-.5 1 1.8 3 5.8 5.4v-7.5",
    fill: "#ad1519"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "m270 261.5a13 13 0 0 0 -5.7 1.9v.2c-.5 1 1.8 3 5.8 5.4v-7.5",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "m295.4 282c.4-1.2-3.8-3.6-9.7-5.8-2.8-1-5-2-7.8-3.2-8.3-3.7-14.4-7.9-13.6-9.4v-.2c-.4.4-1 8-1 8-.8 1.3 4.8 5.5 12.4 9.1 2.4 1.2 7.6 3 10 4 4.3 1.4 8.7 4.3 8.3 5.3l1.4-7.7",
    fill: "#ad1519"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "m295.4 282c.4-1.2-3.8-3.6-9.7-5.8-2.8-1-5-2-7.8-3.2-8.3-3.7-14.4-7.9-13.6-9.4v-.2c-.4.4-1 8-1 8-.8 1.3 4.8 5.5 12.4 9.1 2.4 1.2 7.6 3 10 4 4.3 1.4 8.7 4.3 8.3 5.3l1.4-7.7z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "m263.9 254.4c.6-2.3 1.4-4.4 2.1-6.6h-.5a5.2 5.2 0 0 1 -.5.1 52.8 52.8 0 0 1 -1.4 4.8c-1-1.4-2-2.7-2.7-4.1l-1 .2h-1a131.3 131.3 0 0 1 4 5.7h.5zm6-6.6h-1a8 8 0 0 1 -.8 0v6.2h4.2v-.7h-2.6l.1-5.5m6.8 1 2 .3v-.7l-5.8-.5v.8a19.3 19.3 0 0 1 2 0l-.4 5.6h1.6l.5-5.4m2.4 6c.3 0 .5 0 .8.2l.8.2.7-2.9.6 1.2.8 2.1 1 .2c.4 0 .7.2 1 .3l-.3-.7c-.4-1-1-1.9-1.3-2.9 1 0 1.9-.3 2.1-1.2.1-.6 0-1-.7-1.5-.4-.3-1.2-.4-1.7-.5l-2.4-.5zm3-5.2c.7.2 1.5.3 1.5 1v.5c-.3.9-1 1.2-2 .9zm8 7-.2 2 .8.5.9.5.5-7a3.4 3.4 0 0 1 -.7-.3l-6.1 3.8.5.3.4.2 1.7-1.2 2.3 1.3zm-1.7-1.5 2-1.4-.2 2.3-1.8-1",
    fill: "#c8b100"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "m182.2 192.4c0-1 1-2 2-2s2.2 1 2.2 2c0 1.1-1 2-2.1 2a2 2 0 0 1 -2.1-2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "m205.7 175.4c6.3 0 12 1 15.7 2.4a31.7 31.7 0 0 0 14.6 2.3c2.7 0 6.5.8 10.3 2.4a27.3 27.3 0 0 1 7.4 4.7l-1.5 1.4-.4 3.8-4.1 4.7-2 1.8-5 3.9-2.5.2-.7 2.1-31.6-3.7-31.7 3.7-.8-2.1-2.5-.2-4.9-4-2-1.7-4.1-4.7-.5-3.8-1.5-1.4a27.6 27.6 0 0 1 7.5-4.7 26 26 0 0 1 10.2-2.4c2 .2 4.2.1 6.6-.2a30 30 0 0 0 8-2c3.7-1.5 9-2.5 15.5-2.5z",
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "m206.2 217.1c-11.8 0-22.4-1.4-29.9-3.6a1.1 1.1 0 0 1 -.8-1.2c0-.5.3-1 .8-1.2a109 109 0 0 1 29.9-3.6c11.7 0 22.3 1.4 29.8 3.6a1.3 1.3 0 0 1 0 2.4c-7.5 2.2-18 3.6-29.8 3.6",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "m206.1 215.6c-10.6 0-20.2-1.2-27.5-3.1 7.3-2 16.9-3 27.5-3.1a115 115 0 0 1 27.6 3c-7.3 2-17 3.2-27.6 3.2",
    fill: "#ad1519"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m206.9 215.7v-6.3m-1.7 6.3v-6.3",
    fill: "none",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.6 215.7v-6.3m-1.6 6.3v-6.3",
    fill: "none",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.6 215.7v-6.3m-2.8 5.9v-5.7m1.3 5.8v-6m-3.8 5.6v-5.2m1.3 5.4v-5.6",
    fill: "none",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 214.8v-4.8m1 4.7v-4.7m1.2 5v-5m-3.4 4.7v-4.5",
    fill: "none",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.7 214.5v-4.2m-1.2 4.1v-4",
    fill: "none",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186 214v-3m1.3 3.2v-3.5m-2.5 3.1v-2.8",
    fill: "none",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.7 213.6v-2.3m-1.3 2v-1.8m-1.2 1.6v-1.3",
    fill: "none",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.8 212.8v-.7",
    fill: "none",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.7 215.3v-5.8m-2.9 6v-6.1m-2.1 6.2v-6.3",
    fill: "none",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206 207.4a108 108 0 0 0 -30 3.9c.6-.3.5-1-.3-3-1-2.5-2.4-2.4-2.4-2.4 8.3-2.5 20-4 32.8-4a123 123 0 0 1 33 4s-1.5-.1-2.5 2.3c-.8 2-.8 2.8-.2 3-7.5-2.2-18.4-3.7-30.3-3.7",
    fill: "#c8b100",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.1 201.9c-12.9 0-24.5 1.5-32.8 4a1 1 0 0 1 -1.3-.6 1 1 0 0 1 .7-1.3 121 121 0 0 1 33.4-4.2c13.2 0 25.2 1.7 33.5 4.2.6.2.9.8.7 1.3s-.8.8-1.3.6c-8.4-2.5-20-4-32.9-4",
    fill: "#c8b100",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.1 215.6c-10.6 0-20.2-1.2-27.5-3.1 7.3-2 16.9-3 27.5-3.1a115 115 0 0 1 27.6 3c-7.3 2-17 3.2-27.6 3.2z",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197 204.8c0-.5.4-1 1-1 .5 0 1 .5 1 1s-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.1 205.6h-3.1a1 1 0 0 1 0-2h6.4c.5 0 1 .5 1 1s-.5 1-1 1h-3.2",
    fill: "#ad1519",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.3 206.5-2.3.2c-.6.1-1-.3-1.2-.8a1 1 0 0 1 1-1.1l2.2-.3 2.4-.3c.5 0 1 .3 1.1.9.1.5-.3 1-.9 1z",
    fill: "#058e6e",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181 206.7c0-.6.5-1 1.1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174 208.5 1.2-1.6 3.3.4-2.6 2-1.8-.8",
    fill: "#ad1519",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222 206.5 2.3.2c.5.1 1-.3 1.1-.8a1 1 0 0 0 -.9-1.1l-2.2-.3-2.4-.3a1 1 0 0 0 -1.1.9c-.1.5.3 1 .9 1z",
    fill: "#058e6e",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.3 204.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1 -1-1m15.8 1.9c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.2 208.5-1.1-1.6-3.3.4 2.6 2z",
    fill: "#ad1519",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.3 212.8c7.4-2.1 17.6-3.4 28.8-3.4 11.3 0 21.4 1.3 28.9 3.4",
    fill: "none",
    strokeWidth: 0.4
  }))), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "m182.3 183.8 1.4 1 2-3.2a7.4 7.4 0 0 1 -3.6-7.2c.2-4.1 5.2-7.6 11.7-7.6 3.3 0 6.3 1 8.5 2.4 0-.6 0-1.2.2-1.8a17.4 17.4 0 0 0 -8.7-2.1c-7.4 0-13.2 4.1-13.5 9.1a8.9 8.9 0 0 0 3 7.6z",
    fill: "#c8b100"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "m182.3 183.8 1.4 1 2-3.2a7.4 7.4 0 0 1 -3.6-7.2c.2-4.1 5.2-7.6 11.7-7.6 3.3 0 6.3 1 8.5 2.4 0-.6 0-1.2.2-1.8a17.4 17.4 0 0 0 -8.7-2.1c-7.4 0-13.2 4.1-13.5 9.1a8.9 8.9 0 0 0 3 7.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "m182.4 183.8a9.3 9.3 0 0 1 -4-7.3c0-3.2 2-6.1 5.3-8a8.5 8.5 0 0 0 -3.4 6.8 8.9 8.9 0 0 0 3 6.7z",
    fill: "#c8b100"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "m182.4 183.8a9.3 9.3 0 0 1 -4-7.3c0-3.2 2-6.1 5.3-8a8.5 8.5 0 0 0 -3.4 6.8 8.9 8.9 0 0 0 3 6.7z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "m160.1 187.1a8.8 8.8 0 0 1 -2.3-5.9c0-1.3.3-2.6 1-3.8 2-4.2 8.4-7.2 16-7.2 2 0 4 .2 5.9.6l-1 1.4a25.5 25.5 0 0 0 -4.9-.4c-7 0-12.8 2.7-14.5 6.3a7 7 0 0 0 -.7 3.1 7.3 7.3 0 0 0 2.7 5.6l-2.6 4.1-1.3-1z",
    fill: "#c8b100"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "m160.1 187.1a8.8 8.8 0 0 1 -2.3-5.9c0-1.3.3-2.6 1-3.8 2-4.2 8.4-7.2 16-7.2 2 0 4 .2 5.9.6l-1 1.4a25.5 25.5 0 0 0 -4.9-.4c-7 0-12.8 2.7-14.5 6.3a7 7 0 0 0 -.7 3.1 7.3 7.3 0 0 0 2.7 5.6l-2.6 4.1-1.3-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "m162.7 173.3a10.5 10.5 0 0 0 -4 4.1 8.6 8.6 0 0 0 -.9 3.8c0 2.3.9 4.3 2.3 5.9l-1.5 2.5a10.4 10.4 0 0 1 -2.3-6.5c0-4 2.5-7.5 6.4-9.8",
    fill: "#c8b100"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "m162.7 173.3a10.5 10.5 0 0 0 -4 4.1 8.6 8.6 0 0 0 -.9 3.8c0 2.3.9 4.3 2.3 5.9l-1.5 2.5a10.4 10.4 0 0 1 -2.3-6.5c0-4 2.5-7.5 6.4-9.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "m206 164.4c1.7 0 3.2 1.1 3.5 2.6.3 1.4.4 2.9.4 4.5v1.1c.1 3.3.6 6.3 1.3 8.1l-5.2 5-5.2-5c.7-1.8 1.2-4.8 1.3-8.1v-1.1c0-1.6.2-3.1.4-4.5.3-1.5 1.8-2.6 3.5-2.6",
    fill: "#c8b100"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "m206 164.4c1.7 0 3.2 1.1 3.5 2.6.3 1.4.4 2.9.4 4.5v1.1c.1 3.3.6 6.3 1.3 8.1l-5.2 5-5.2-5c.7-1.8 1.2-4.8 1.3-8.1v-1.1c0-1.6.2-3.1.4-4.5.3-1.5 1.8-2.6 3.5-2.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "m206 166c1 0 1.7.6 1.8 1.4.2 1.2.4 2.6.4 4.2v1c.1 3.2.6 6 1.2 7.7l-3.4 3.2-3.4-3.2c.7-1.7 1.1-4.5 1.2-7.7v-1a28.1 28.1 0 0 1 .4-4.2 2 2 0 0 1 1.8-1.4",
    fill: "#c8b100"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "m206 166c1 0 1.7.6 1.8 1.4.2 1.2.4 2.6.4 4.2v1c.1 3.2.6 6 1.2 7.7l-3.4 3.2-3.4-3.2c.7-1.7 1.1-4.5 1.2-7.7v-1a28.1 28.1 0 0 1 .4-4.2 2 2 0 0 1 1.8-1.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "m229.7 183.8-1.3 1-2-3.2a7.4 7.4 0 0 0 3.6-6.3 7 7 0 0 0 0-.9c-.2-4.1-5.3-7.6-11.7-7.6a15 15 0 0 0 -8.5 2.4 23 23 0 0 0 -.2-1.8 17.4 17.4 0 0 1 8.7-2.1c7.4 0 13.2 4.1 13.4 9.1a8.9 8.9 0 0 1 -3 7.6z",
    fill: "#c8b100"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "m229.7 183.8-1.3 1-2-3.2a7.4 7.4 0 0 0 3.6-6.3 7 7 0 0 0 0-.9c-.2-4.1-5.3-7.6-11.7-7.6a15 15 0 0 0 -8.5 2.4 23 23 0 0 0 -.2-1.8 17.4 17.4 0 0 1 8.7-2.1c7.4 0 13.2 4.1 13.4 9.1a8.9 8.9 0 0 1 -3 7.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "m229.6 183.8a9.1 9.1 0 0 0 4.1-7.3c0-3.2-2.1-6.1-5.3-8a8.5 8.5 0 0 1 3.4 6.8 8.9 8.9 0 0 1 -3.2 6.7z",
    fill: "#c8b100"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "m229.6 183.8a9.1 9.1 0 0 0 4.1-7.3c0-3.2-2.1-6.1-5.3-8a8.5 8.5 0 0 1 3.4 6.8 8.9 8.9 0 0 1 -3.2 6.7z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "m252 187.1a8.8 8.8 0 0 0 2.2-5.9 8.7 8.7 0 0 0 -.9-3.8c-2-4.2-8.4-7.2-16-7.2a29 29 0 0 0 -6 .6l1 1.4a25.4 25.4 0 0 1 5-.4c7 0 12.8 2.7 14.4 6.3.5 1 .7 2 .7 3.1a7.3 7.3 0 0 1 -2.6 5.6l2.5 4.1 1.3-1-1.7-2.8",
    fill: "#c8b100"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "m252 187.1a8.8 8.8 0 0 0 2.2-5.9 8.7 8.7 0 0 0 -.9-3.8c-2-4.2-8.4-7.2-16-7.2a29 29 0 0 0 -6 .6l1 1.4a25.4 25.4 0 0 1 5-.4c7 0 12.8 2.7 14.4 6.3.5 1 .7 2 .7 3.1a7.3 7.3 0 0 1 -2.6 5.6l2.5 4.1 1.3-1-1.7-2.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "m249.3 173.3a10.6 10.6 0 0 1 4 4.1 8.7 8.7 0 0 1 .9 3.8 8.8 8.8 0 0 1 -2.3 5.9l1.6 2.5a10.4 10.4 0 0 0 2.3-6.5c0-4-2.6-7.5-6.5-9.8",
    fill: "#c8b100"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "m249.3 173.3a10.6 10.6 0 0 1 4 4.1 8.7 8.7 0 0 1 .9 3.8 8.8 8.8 0 0 1 -2.3 5.9l1.6 2.5a10.4 10.4 0 0 0 2.3-6.5c0-4-2.6-7.5-6.5-9.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "m204.2 181.4c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 0 1 -1.8-1.7",
    fill: "#fff"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "m204.2 181.4c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 0 1 -1.8-1.7z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "m204.2 178c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 0 1 -1.8-1.7m.4-3.7c0-.7.6-1.3 1.4-1.3s1.5.6 1.5 1.3c0 .8-.7 1.4-1.5 1.4s-1.4-.6-1.4-1.4m.4-3.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1 -1-1m.2-2.8c0-.5.4-.8.8-.8.5 0 .9.3.9.8 0 .4-.4.8-.9.8a.8.8 0 0 1 -.8-.8",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "m206.2 191.8 1.2.2a4.6 4.6 0 0 0 4.5 6 4.7 4.7 0 0 0 4.4-3c.1 0 .5-1.7.7-1.7s.1 1.8.2 1.7c.3 2.3 2.4 3.8 4.7 3.8a4.6 4.6 0 0 0 4.7-5l1.5-1.5.7 2a4 4 0 0 0 -.4 1.9 4.4 4.4 0 0 0 4.5 4.2c1.6 0 3-.7 3.8-1.9l.9-1.2v1.5c0 1.5.6 2.8 2 3 0 0 1.7.1 4-1.6 2.1-1.7 3.3-3.1 3.3-3.1l.2 1.7s-1.8 2.8-3.8 4c-1 .6-2.7 1.3-4 1-1.4-.2-2.4-1.3-3-2.6a6.7 6.7 0 0 1 -3.3 1 6.5 6.5 0 0 1 -6.1-3.7 7 7 0 0 1 -10.4-.3 7 7 0 0 1 -4.6 1.8 6.9 6.9 0 0 1 -5.7-3 6.9 6.9 0 0 1 -5.7 3 7 7 0 0 1 -4.7-1.8 7 7 0 0 1 -10.4.3 6.5 6.5 0 0 1 -6 3.7 6.7 6.7 0 0 1 -3.4-1c-.6 1.3-1.5 2.4-3 2.7-1.2.2-2.9-.5-4-1.1-2-1.2-3.8-4-3.8-4l.2-1.7s1.2 1.4 3.4 3.1c2.2 1.8 3.9 1.6 3.9 1.6 1.4-.2 2-1.5 2-3v-1.5l1 1.2a4.6 4.6 0 0 0 3.7 2c2.5 0 4.5-2 4.5-4.3a4 4 0 0 0 -.4-2l.8-1.9 1.5 1.5a4.4 4.4 0 0 0 0 .6c0 2.4 2 4.4 4.6 4.4 2.4 0 4.4-1.5 4.7-3.8 0 0 0-1.6.2-1.7.2 0 .6 1.7.7 1.6a4.7 4.7 0 0 0 4.5 3.1 4.6 4.6 0 0 0 4.5-6z",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "m238.6 197.7c.3-.8 0-1.6-.6-1.8-.5-.2-1.2.3-1.5 1.1s0 1.6.6 1.8c.5.2 1.2-.3 1.5-1.1m-20.5-4c0-.8-.3-1.6-1-1.6-.5-.1-1 .5-1.2 1.4-.1.8.3 1.5.9 1.6.6 0 1.2-.6 1.3-1.4m-23.9 0c0-.8.4-1.6 1-1.6.6-.1 1.1.5 1.2 1.4.1.8-.3 1.5-.9 1.6-.6 0-1.1-.6-1.2-1.4m-20.6 4c-.2-.8 0-1.6.6-1.8s1.2.3 1.5 1.1 0 1.6-.5 1.8c-.6.2-1.3-.3-1.6-1.1",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "m182.7 184a5.1 5.1 0 0 1 2.2 2.9s0-.3.6-.6 1-.3 1-.3l-.1 1.3-.3 2.2a7.4 7.4 0 0 1 -.7 1.6 1.9 1.9 0 0 0 -1.5-.4 1.8 1.8 0 0 0 -1.2.9s-.7-.6-1.2-1.3l-1.1-2-.7-1.1s.5-.2 1.1 0c.6 0 .8.2.8.2a4.9 4.9 0 0 1 1-3.4m.4 9.8a1.8 1.8 0 0 1 -.6-1c0-.5 0-.9.3-1.2 0 0-.9-.5-1.8-.7-.7-.2-2-.2-2.3-.2h-1l.2.5c.2.5.5.7.5.7a5 5 0 0 0 -3 2 5.3 5.3 0 0 0 3.5 1l-.2.8v.6l1-.4c.3-.1 1.5-.5 2-1 .8-.4 1.5-1.1 1.5-1.1m2.7-.5a1.6 1.6 0 0 0 .2-1.1 1.7 1.7 0 0 0 -.6-1l1.4-1.3a10 10 0 0 1 2-.9l1.1-.4v.6a5.7 5.7 0 0 1 -.2.8 5 5 0 0 1 3.4 1 5 5 0 0 1 -2.9 2 6.4 6.4 0 0 0 .7 1.2h-1c-.4 0-1.6 0-2.3-.2a11 11 0 0 1 -1.8-.7",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "m182.2 192.4c0-1 1-2 2-2s2.2 1 2.2 2c0 1.1-1 2-2.1 2a2 2 0 0 1 -2.1-2",
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "m206.1 180.8a5.7 5.7 0 0 1 1.9 3.7s.2-.3.9-.5c.7-.3 1.2-.2 1.2-.2l-.5 1.4-.8 2.4a8.2 8.2 0 0 1 -1 1.7 2.1 2.1 0 0 0 -1.7-.7c-.6 0-1.2.3-1.6.7 0 0-.6-.7-1-1.7l-.8-2.4-.5-1.4 1.2.2c.7.2.9.5.9.5 0-1.4.8-2.8 1.8-3.7",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "m204.6 191.8a2 2 0 0 1 -.5-1.2c0-.5.1-1 .4-1.3 0 0-.8-.7-1.8-1-.7-.4-2-.7-2.5-.7l-1.2-.2.2.6.4.9a5.9 5.9 0 0 0 -3.7 1.7c1 .9 2.3 1.6 3.7 1.6l-.4 1-.2.6 1.2-.2c.4-.1 1.8-.4 2.5-.7 1-.4 1.9-1 1.9-1m3 0a1.9 1.9 0 0 0 .1-2.6s.9-.7 1.8-1a8 8 0 0 1 2.5-.7l1.2-.3-.1.7-.4.9c1.4 0 2.7.8 3.6 1.7a5.9 5.9 0 0 1 -3.6 1.6 6.9 6.9 0 0 0 .5 1.6l-1.2-.2-2.5-.7c-1-.4-1.8-1-1.8-1m22-8a5.2 5.2 0 0 0 -2.2 3l-.7-.6c-.6-.3-1-.3-1-.3l.2 1.3c0 .3 0 1.3.3 2.2.2 1 .6 1.6.6 1.6a2 2 0 0 1 1.5-.4c.6.1 1 .5 1.3.9l1.1-1.3c.6-.8 1-1.7 1.1-2l.7-1.1s-.4-.2-1 0c-.7 0-1 .2-1 .2a4.9 4.9 0 0 0 -1-3.4m-.3 9.8c.3-.3.5-.6.6-1a1.6 1.6 0 0 0 -.2-1.2s.8-.5 1.7-.7c.7-.2 2-.2 2.3-.2h1.1l-.3.5a6.2 6.2 0 0 1 -.4.7 5 5 0 0 1 2.9 2 5.3 5.3 0 0 1 -3.5 1l.2.8v.6l-1-.4c-.3-.1-1.4-.5-2-1-.8-.4-1.4-1.1-1.4-1.1m-2.8-.5a1.7 1.7 0 0 1 -.2-1.1c0-.5.3-.8.6-1 0 0-.6-.8-1.4-1.3-.6-.4-1.7-.8-2-.9a171.4 171.4 0 0 1 -1-.4v.6c0 .5.2.8.2.8a5.2 5.2 0 0 0 -3.5 1c.7.9 1.7 1.7 3 2 0 0-.3.2-.5.7l-.3.5h1c.4 0 1.7 0 2.3-.2a11.1 11.1 0 0 0 1.8-.7",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "m226 192.4c0-1 1-2 2-2s2.1 1 2.1 2a2 2 0 0 1 -2 2 2 2 0 0 1 -2.1-2m23.2 4.4c-.4-.5-1.4-.4-2.2.2-.8.7-1 1.6-.5 2.2.5.5 1.5.4 2.3-.3.7-.6 1-1.6.5-2",
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "m246.3 198 .7-1c.7-.6 1.8-.7 2.3-.2l.1.2s1-2 2.3-2.6c1.3-.7 3.4-.5 3.4-.5a2.8 2.8 0 0 0 -2.9-2.8 3 3 0 0 0 -2.4 1l-.2-1s-1.3.3-1.9 1.8 0 3.6 0 3.6-.3-.9-.7-1.5a8 8 0 0 0 -2.4-1.6l-1.3-.7-.1.5a5 5 0 0 0 0 .8 7.9 7.9 0 0 0 -3.7.5 4.7 4.7 0 0 0 2.5 2.2l-.8.7a4 4 0 0 0 -.4.5l1.3.2 2.5.2a14.5 14.5 0 0 0 1.7-.2m-80.3 0c0-.4-.3-.7-.7-1-.7-.7-1.7-.8-2.2-.3l-.2.3s-1-2-2.3-2.7c-1.2-.7-3.3-.5-3.3-.5a2.8 2.8 0 0 1 2.8-2.8c1 0 1.9.4 2.4 1l.2-1s1.3.3 2 1.8c.5 1.5-.1 3.6-.1 3.6s.3-.9.8-1.5a8 8 0 0 1 2.4-1.6l1.3-.7v1.3a7.9 7.9 0 0 1 3.7.5 4.7 4.7 0 0 1 -2.5 2.2l.8.7.4.5-1.2.2-2.6.2a14.7 14.7 0 0 1 -1.7-.2",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "m163 196.8c.6-.5 1.6-.4 2.4.3.7.6 1 1.5.4 2-.5.6-1.5.5-2.2-.2-.8-.6-1-1.6-.5-2m41-6.3c0-1.1.9-2 2-2s2.1.9 2.1 2c0 1-1 2-2 2a2 2 0 0 1 -2.1-2",
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "m201.8 160.6c0-2.2 1.9-4 4.3-4s4.2 1.8 4.2 4-1.9 4-4.3 4a4.1 4.1 0 0 1 -4.2-4",
    fill: "#005bbf",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "m205 149.3v2.2h-2.4v2.2h2.3v6.3h-2.9l-.2.6c0 .6.1 1.1.3 1.6h7.9c.2-.5.3-1 .3-1.6l-.2-.6h-2.8v-6.3h2.3v-2.2h-2.3v-2.2h-2.4z",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "m206.5 330.6a82 82 0 0 1 -35.5-8.2 22.7 22.7 0 0 1 -12.8-20.4v-32h96.4v32a22.7 22.7 0 0 1 -12.8 20.4 81 81 0 0 1 -35.3 8.2",
    fill: "#ccc"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "m206.5 330.6a82 82 0 0 1 -35.5-8.2 22.7 22.7 0 0 1 -12.8-20.4v-32h96.4v32a22.7 22.7 0 0 1 -12.8 20.4 81 81 0 0 1 -35.3 8.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "m206.3 270h48.3v-53.5h-48.3z",
    fill: "#ccc"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "m206.3 270h48.3v-53.5h-48.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "m206.3 302c0 12.6-10.7 22.9-24 22.9s-24.2-10.3-24.2-23v-32h48.2v32",
    fill: "#ad1519"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "m168.6 320.9c1.5.8 3.6 2 5.8 2.6l-.1-54.7h-5.7v52z",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "m158 301.6a24.4 24.4 0 0 0 5.5 15v-47.5h-5.4v32.5z",
    fill: "#c8b100",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "m179.4 324.7a26.6 26.6 0 0 0 5.6 0v-55.9h-5.6v56z",
    fill: "#c7b500",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "m190 323.5a19 19 0 0 0 5.8-2.5v-52.2h-5.8l-.1 54.7z",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "m158.1 270h48.2v-53.5h-48.3v53.5z",
    fill: "#ad1519"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "m158.1 270h48.2v-53.5h-48.3v53.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "m201 316c2.4-2 4.6-6.8 5.4-12.2l.1-35h-5.5l.1 47.3z",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "m206.3 302c0 12.6-10.7 22.9-24 22.9s-24.2-10.3-24.2-23v-32h48.2v32",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "m254.6 270v32c0 12.6-10.8 22.9-24.1 22.9s-24.2-10.3-24.2-23v-32h48.3",
    fill: "#ad1519"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "m254.6 270v32c0 12.6-10.8 22.9-24.1 22.9s-24.2-10.3-24.2-23v-32h48.3",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "m215.1 294.1.1.5c0 .6-.5 1-1.1 1a1 1 0 0 1 -1.1-1v-.5h-1.5a2.5 2.5 0 0 0 1.8 2.9v3.9h1.6v-3.9a2.6 2.6 0 0 0 1.7-1.6h4.4v-1.2h-6m21.8 0v1.2h-4a2.5 2.5 0 0 1 -.3.6l4.6 5.2-1.2 1-4.6-5.3-.2.1v8.7h-1.6v-8.7h-.2l-4.8 5.2-1.2-1 4.7-5.3a2.1 2.1 0 0 1 -.2-.4h-4v-1.5h13zm2.6 0v1.2h4.4c.3.8.9 1.4 1.7 1.6v3.9h1.6v-3.9a2.5 2.5 0 0 0 1.8-2.4 2 2 0 0 0 0-.5h-1.6l.1.5c0 .6-.5 1-1 1-.7 0-1.2-.4-1.2-1a1 1 0 0 1 .1-.5h-5.9m-6.7 22.1a15.6 15.6 0 0 0 3.7-1l.8 1.4a17.6 17.6 0 0 1 -4.3 1.2 2.6 2.6 0 0 1 -2.6 2 2.6 2.6 0 0 1 -2.5-2 17.5 17.5 0 0 1 -4.6-1.2l.8-1.4c1.3.5 2.6.9 4 1a2.5 2.5 0 0 1 1.5-1.3v-6.7h1.6v6.7c.7.2 1.3.7 1.6 1.4zm-11-2.2-.8 1.4a16.6 16.6 0 0 1 -3.6-3.1c-.9.2-1.8 0-2.5-.5a2.4 2.4 0 0 1 -.3-3.5l.1-.1a15.3 15.3 0 0 1 -1.3-4.8h1.7a13.1 13.1 0 0 0 1 4c.5 0 1 0 1.4.2l4.1-4.5 1.3 1-4.1 4.5c.5.9.5 2-.1 2.8a15.2 15.2 0 0 0 3.1 2.6zm-6-4.8c.3-.4 1-.5 1.5 0s.5 1 .1 1.4a1.2 1.2 0 0 1 -1.6.1 1 1 0 0 1 0-1.5zm-2.2-4.5-1.6-.3-.3-4.3 1.7-.6v2.5c0 1 0 1.8.2 2.7zm1.4-5.3 1.7.4v2.2c0-.8.3 2.1.3 2.1l-1.7.6a14 14 0 0 1 -.3-2.7zm5.6 13.7a15.7 15.7 0 0 0 4.8 2.6l.4-1.6a13.7 13.7 0 0 1 -4-2zm-.8 1.4a17.4 17.4 0 0 0 4.8 2.6l-1.2 1.1a18.7 18.7 0 0 1 -4-2zm2.2-9.4 1.6.7 3-3.3-1-1.4zm-1.3-1-1-1.4 3-3.3 1.6.7zm18.1 9.9.8 1.4a16.7 16.7 0 0 0 3.6-3.1c.9.2 1.8 0 2.5-.5a2.4 2.4 0 0 0 .3-3.5l-.1-.1a15 15 0 0 0 1.3-4.8h-1.7a13.3 13.3 0 0 1 -1 4 3 3 0 0 0 -1.4.2l-4.1-4.5-1.3 1 4.1 4.5a2.4 2.4 0 0 0 .1 2.8 15 15 0 0 1 -3.1 2.6zm6-4.8a1.2 1.2 0 0 0 -1.5 0 1 1 0 0 0 -.1 1.4 1.2 1.2 0 0 0 1.6.1 1 1 0 0 0 0-1.5zm2.2-4.5 1.6-.3.3-4.3-1.7-.6v2.5c0 1 0 1.9-.2 2.8zm-1.4-5.3-1.7.4v2.2c0-.8-.3 2.1-.3 2.1l1.7.6.3-2.7zm-5.6 13.7a15.7 15.7 0 0 1 -4.8 2.6l-.4-1.6a13.7 13.7 0 0 0 4-2zm.8 1.4a17.4 17.4 0 0 1 -4.8 2.6l1.2 1.1a18.6 18.6 0 0 0 4-2zm-2.2-9.4-1.6.7-2.9-3.3 1-1.4zm1.3-1 1-1.4-3-3.3-1.6.7zm-20.1-8.7.5 1.6h4.5l.5-1.6zm21.1 0-.5 1.6h-4.5l-.5-1.6zm-11.6 21.9c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1 -1.2-1zm1.9-7.8 1.7-.4v-4.3l-1.7-.5zm-1.6 0-1.7-.4v-4.3l1.7-.5z",
    fill: "#c8b100"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "m211.5 294.2c.2-1 1-1.6 1.8-2v-5.2h1.6v5.3c.8.3 1.5.9 1.7 1.6h4.4v.3h-6a1.2 1.2 0 0 0 -1-.6c-.4 0-.7.3-1 .6zm12.2 0v-.3h4.1a2.4 2.4 0 0 1 .2-.3l-5-5.7 1.2-1 5 5.6.2-.1v-7.4h1.6v7.3h.3l4.9-5.5 1.2 1-4.9 5.5.3.6h4v.3h-13zm21.6 0a1.1 1.1 0 0 1 1-.6c.5 0 .8.3 1 .6h1.6c-.2-1-.9-1.6-1.8-2v-5.2h-1.6v5.3c-.8.3-1.4.8-1.7 1.6h-4.4v.3h6m-30.2-15 6 6.8 1.3-1-6.1-6.7.3-.6h4.4v-1.7h-4.4a2.6 2.6 0 0 0 -2.5-1.7 2.6 2.6 0 0 0 -2.7 2.5 2.5 2.5 0 0 0 1.8 2.4v5.2h1.6v-5.2zm32 0v5.3h-1.7v-5.2a2.5 2.5 0 0 1 -.4-.2l-6 6.8-1.3-1 6.2-6.9-.1-.3h-4.5v-1.7h4.5a2.6 2.6 0 0 1 2.4-1.7 2.6 2.6 0 0 1 2.7 2.5 2.5 2.5 0 0 1 -1.9 2.4zm-16.1 0v3.3h-1.7v-3.2a2.6 2.6 0 0 1 -1.7-1.6h-4v-1.7h4a2.6 2.6 0 0 1 2.5-1.7c1.2 0 2.2.7 2.5 1.7h4v1.6h-4a2.5 2.5 0 0 1 -1.6 1.6zm-17.8 4-1.7.4v4.3l1.7.5zm1.6 0 1.7.4v4.3l-1.7.5zm30.6 0-1.7.4v4.3l1.7.5zm1.6 0 1.7.4v4.3l-1.7.5zm-25.5.8 1.6-.7 2.9 3.3-1 1.4zm-1.3 1-1 1.4 3 3.3 1.6-.7zm18.5-1.1-1.6-.7-3 3.3 1 1.4zm1.2 1 1 1.4-3 3.3-1.5-.7zm-20.3 9 .5-1.6h4.5l.5 1.6zm-6.7-17c0-.6.5-1 1.2-1a1 1 0 0 1 1 1c0 .6-.4 1-1 1a1.1 1.1 0 0 1 -1.2-1zm12.1.8-.5 1.6h-4.5l-.5-1.6zm0-1.6-.5-1.6h-4.5l-.5 1.6zm15.7 17.8-.5-1.6h-4.5l-.5 1.6zm4.4-17c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1 -1.2-1zm-16.1 0c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1.1 1a1.1 1.1 0 0 1 -1.1-1zm6.2.8.5 1.6h4.6l.5-1.6zm0-1.6.5-1.6h4.6l.5 1.6zm-5.9 5-1.7.5v4.3l1.7.5v-5.4m1.7 0 1.6.5v4.3l-1.6.5z",
    fill: "#c8b100"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "m232.7 316.3a15.6 15.6 0 0 0 3.7-1.1l.8 1.4a17.6 17.6 0 0 1 -4.3 1.2 2.6 2.6 0 0 1 -2.6 2 2.6 2.6 0 0 1 -2.5-2 17.5 17.5 0 0 1 -4.6-1.2l.8-1.4c1.3.5 2.6.9 4 1a2.5 2.5 0 0 1 1.5-1.3v-6.7h1.6v6.7c.7.2 1.3.7 1.6 1.4zm-4.7-20.4a2.3 2.3 0 0 1 -.2-.5h-4v-1.4h4a2.6 2.6 0 0 1 .2-.4l-5-5.6 1.2-1 5 5.5a2.2 2.2 0 0 1 .2 0v-7.5h1.7v7.3h.2l4.9-5.5 1.2 1-4.9 5.5.3.6h4v1.5h-4c0 .2-.2.4-.3.5l4.7 5.3-1.3 1-4.6-5.3-.2.1v8.7h-1.6v-8.7l-.2-.1-4.8 5.3-1.2-1zm-12.8-16.7 6 6.8 1.3-1-6.1-6.7.3-.6h4.4v-1.7h-4.4a2.6 2.6 0 0 0 -2.5-1.7 2.6 2.6 0 0 0 -2.6 2.5 2.5 2.5 0 0 0 1.7 2.4v5.2h1.6v-5.2zm6.5 34.8-.8 1.4a16.6 16.6 0 0 1 -3.6-3.1c-.9.2-1.8 0-2.5-.5a2.4 2.4 0 0 1 -.3-3.5l.1-.1a15.3 15.3 0 0 1 -1.2-4.8h1.6a13.1 13.1 0 0 0 1 4c.5 0 1 0 1.4.2l4.1-4.5 1.3 1-4.1 4.5c.6.9.5 2-.1 2.8a15.2 15.2 0 0 0 3.1 2.6zm-8.4-13.1v-3.9a2.5 2.5 0 0 1 -1.8-2.4c0-1 .8-2 1.8-2.4v-5.2h1.6v5.3c.8.2 1.5.8 1.7 1.6h4.4v1.5h-4.4a2.6 2.6 0 0 1 -1.6 1.6v3.9zm2.3 8.3c.4-.4 1.1-.5 1.6 0s.5 1 .1 1.4a1.2 1.2 0 0 1 -1.6.1 1 1 0 0 1 0-1.5zm-2-4.5-1.7-.3-.3-4.3 1.7-.6v2.5c0 1 0 1.8.3 2.7zm1.4-5.3 1.6.4v2.2c0-.8.3 2.1.3 2.1l-1.7.6-.3-2.7v-2.6zm5.5 13.7a15.7 15.7 0 0 0 4.8 2.6l.4-1.6a13.7 13.7 0 0 1 -4-2zm-.8 1.4a17.4 17.4 0 0 0 4.8 2.6l-1.2 1.1a18.7 18.7 0 0 1 -4-2z",
    fill: "none",
    stroke: "#c8b100",
    strokeWidth: 0.3
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "m221.9 305.1 1.6.7 3-3.3-1-1.4zm-1.3-1-1-1.4 3-3.3 1.6.7zm-7.6-9.5c0-.6.5-1 1-1 .7 0 1.2.5 1.2 1 0 .6-.5 1.1-1.1 1.1a1 1 0 0 1 -1.1-1zm25.7 19.4.8 1.4a16.7 16.7 0 0 0 3.6-3.1c.9.2 1.8 0 2.6-.5a2.4 2.4 0 0 0 .2-3.5l-.1-.1a15 15 0 0 0 1.3-4.8h-1.7a13.3 13.3 0 0 1 -1 4 3 3 0 0 0 -1.4.2l-4.1-4.5-1.3 1 4.1 4.5a2.4 2.4 0 0 0 .1 2.8 15 15 0 0 1 -3 2.6zm8.4-13.1v-3.9a2.5 2.5 0 0 0 1.8-2.4c0-1-.7-2-1.8-2.4v-5.2h-1.6v5.3c-.8.2-1.4.8-1.7 1.6h-4.4v1.5h4.4c.3.8.9 1.3 1.7 1.6v3.9zm-2.3 8.3a1.2 1.2 0 0 0 -1.6 0 1 1 0 0 0 -.1 1.4 1.2 1.2 0 0 0 1.6.1 1 1 0 0 0 0-1.5zm2-4.5 1.7-.3.3-4.3-1.7-.6v2.5c0 1 0 1.8-.2 2.7zm-1.3-5.3-1.7.4v2.2c0-.8-.3 2.1-.3 2.1l1.7.6.3-2.7zm1.6-20.1v5.2h-1.6v-5.2a2.3 2.3 0 0 1 -.4-.2l-6 6.8-1.2-1 6-7v-.2h-4.5v-1.7h4.4a2.6 2.6 0 0 1 2.5-1.7 2.6 2.6 0 0 1 2.6 2.5 2.5 2.5 0 0 1 -1.8 2.4zm-16 0v3.2h-1.7v-3.2a2.6 2.6 0 0 1 -1.7-1.6h-4v-1.7h4c.4-1 1.3-1.7 2.5-1.7s2.2.7 2.5 1.7h4v1.6h-4a2.5 2.5 0 0 1 -1.6 1.6zm8.8 33.8a15.7 15.7 0 0 1 -4.8 2.6l-.4-1.6a13.7 13.7 0 0 0 4-2zm.8 1.4a17.4 17.4 0 0 1 -4.8 2.6l1.2 1.1a18.7 18.7 0 0 0 4-2zm-27.4-31.4-1.7.5v4.3l1.7.5v-5.2m1.7 0 1.6.4v4.3l-1.6.5v-5.4m30.5 0-1.7.5v4.3l1.7.5z",
    fill: "none",
    stroke: "#c8b100",
    strokeWidth: 0.3
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "m247.1 283.1 1.7.5v4.3l-1.7.5v-5.4m-8.6 22-1.6.7-2.9-3.3 1-1.4zm1.3-1 1-1.4-3-3.3-1.6.7zm-18.2-20 1.6-.7 3 3.3-1 1.4zm-1.3 1-1 1.4 3 3.3 1.6-.7zm18.5-1.1-1.6-.7-3 3.3 1 1.4zm1.2 1 1 1.4-3 3.2-1.5-.6zm-20.3 9 .5-1.6h4.5l.5 1.6zm0 1.5.5 1.6h4.5l.5-1.6zm-6.7-18.4c0-.6.5-1 1.2-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1 -1.2-1zm12.1.8-.5 1.6h-4.5l-.5-1.6zm0-1.6-.5-1.6h-4.5l-.5 1.6zm20.1 18.5c0-.5.5-1 1.1-1s1.1.5 1.1 1c0 .6-.5 1.1-1 1.1a1 1 0 0 1 -1.2-1zm-4.4-.7-.5-1.6h-4.5l-.5 1.6zm0 1.5-.5 1.6h-4.5l-.5-1.6zm-11.6 21.9c0-.6.5-1 1.1-1s1.1.4 1.1 1-.5 1-1 1a1.1 1.1 0 0 1 -1.2-1zm1.9-7.8 1.7-.4v-4.3l-1.7-.5zm-1.6 0-1.7-.4v-4.3l1.7-.5zm15.7-32.6c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1 -1.2-1zm-16.1 0c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1 -1.2-1zm6.2.8.5 1.6h4.6l.5-1.6h-5.5m0-1.6.4-1.6h4.6l.5 1.6zm-6 5-1.6.5v4.3l1.6.5v-5.5m1.7 0 1.6.5v4.3l-1.6.5z",
    fill: "none",
    stroke: "#c8b100",
    strokeWidth: 0.3
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "m227.7 294.7a2.6 2.6 0 0 1 2.6-2.5 2.6 2.6 0 0 1 2.6 2.5 2.6 2.6 0 0 1 -2.6 2.4c-1.4 0-2.6-1-2.6-2.4",
    fill: "#058e6e"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "m230.9 229.7v-.6l.1-.3-2.3-.1a5.9 5.9 0 0 1 -2.3-1.2c-.8-.7-1.1-1-1.6-1.2-1.3-.2-2.3.4-2.3.4s1 .4 1.7 1.3 1.5 1.3 1.8 1.4c.6.2 2.6 0 3.1.1z",
    fill: "#db4446"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "m230.9 229.7v-.6l.1-.3-2.3-.1a5.9 5.9 0 0 1 -2.3-1.2c-.8-.7-1.1-1-1.6-1.2-1.3-.2-2.3.4-2.3.4s1 .4 1.7 1.3 1.5 1.3 1.8 1.4c.6.2 2.6 0 3.1.1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "m238.1 227.5v1.4c.2.6-.1 1.2 0 1.5 0 .4.1.6.3.9l.2.9-.7-.5-.6-.4v1c.1.2.3.8.6 1.1l1 1.3c.2.5.1 1.4.1 1.4s-.4-.7-.8-.8l-1.2-.7s.7.8.7 1.5c0 .8-.3 1.6-.3 1.6s-.3-.7-.8-1.1l-1-.9s.4 1.2.4 2v2.3l-.9-1-1-.7c0-.2.5.6.6 1.1 0 .5.3 2.3 1.8 4.5 1 1.3 2.3 3.6 5.3 2.9 3-.8 1.9-4.8 1.3-6.7a16.8 16.8 0 0 1 -1-4.6c0-.8.6-2.9.5-3.3a8 8 0 0 1 .2-3.1c.4-1.3.7-1.8.9-2.3.2-.6.4-.9.4-1.3l.1-1.3.7 1.3.1 1.5s.1-1 1-1.6c.8-.6 1.8-1.1 2-1.4.3-.3.3-.5.3-.5s0 1.8-.6 2.6l-1.7 2s.7-.3 1.2-.3h.9s-.6.4-1.4 1.6c-.8 1-.5 1.2-1 2.1-.6 1-1 1-1.7 1.5-1 .8-.5 4.2-.4 4.7.2.5 2 4.5 2 5.5s.2 3.2-1.5 4.6c-1.1 1-3 1-3.4 1.2-.4.3-1.2 1.1-1.2 2.8s.6 2 1 2.4c.6.5 1.2.2 1.3.6.2.3.2.5.5.7.2.2.3.4.2.8 0 .3-.8 1.1-1.1 1.7l-.8 2.4c0 .2-.1 1 .1 1.3 0 0 .9 1 .3 1.2-.4.2-.8-.2-1-.2l-.9.5c-.3-.1-.3-.3-.4-.8l-.1-.7c-.2 0-.3.2-.4.5 0 .2 0 .8-.3.8-.2 0-.5-.4-.8-.5-.2 0-.8-.2-.8-.4 0-.3.4-.9.7-1 .4 0 .8-.3.5-.5s-.5-.2-.7 0-.8 0-.7-.2v-.8c0-.2-.4-.5.1-.8.6-.3.8.2 1.4.1.6 0 .8-.3 1-.6s.2-1-.2-1.4c-.4-.5-.7-.5-.9-.8l-.3-.9v2.2l-.7-.8c-.3-.3-.6-1.3-.6-1.3v1.3c0 .4.3.7.2.8s-.8-.7-1-.8a3.7 3.7 0 0 1 -1-1l-.4-1.4a4.2 4.2 0 0 1 0-1.5l.4-1h-1.4c-.7 0-1.2-.3-1.5.2s-.2 1.5.2 2.8c.3 1.2.5 1.9.4 2.1a3 3 0 0 1 -.7.8h-.9a2.5 2.5 0 0 0 -1.2-.3h-1.3l-1.1-.3c-.3.1-.8.3-.6.7.2.6-.2.7-.5.7l-.9-.2c-.4-.1-.9 0-.8-.4 0-.4.2-.4.4-.7s.2-.5 0-.5h-.6c-.2.2-.5.5-.8.4-.2-.1-.4-.4-.4-1s-.7-1.2 0-1.1c.5 0 1.3.4 1.4 0 .2-.3 0-.4-.2-.7s-.8-.4-.3-.7l.7-.5c.1-.2.4-.8.7-.6.6.2 0 .7.6 1.3.6.7 1 1 2 .8 1 0 1.3-.2 1.3-.5l-.1-1v-1s-.4.3-.5.6l-.4.8v-2a8 8 0 0 0 -.2-.8l-.3.9-.1 1s-.7-.5-.5-1.5c.1-.7-.1-1.6.1-2 .2-.3.7-1.5 2-1.6h2.6l2-.3s-2.8-1.4-3.5-1.9a9.5 9.5 0 0 1 -2-2l-.6-1.6s-.5 0-1 .3a5 5 0 0 0 -1.2 1l-.7 1 .1-1.2v-.8s-.4 1.2-1 1.7l-1.4 1v-.8l.2-1s-.4.8-1.1 1c-.7 0-1.8 0-1.9.4 0 .5.2 1 0 1.4 0 .3-.4.5-.4.5l-.8-.4c-.4 0-.7.2-.7.2s-.3-.4-.2-.7c.1-.2.7-.6.5-.8l-.8.2c-.3.1-.8.3-.8-.2 0-.4.2-.7 0-1 0-.3 0-.5.2-.6l1.2-.1c0-.2-.2-.5-.8-.6s-.8-.5-.5-.8c.3-.2.3-.3.5-.6.1-.2.2-.7.7-.5.5.3.4.8 1 1a4 4 0 0 0 2-.2l1.5-1 1.5-1-1-.8c-.3-.3-.7-.9-1-1a8.3 8.3 0 0 0 -1.8-.6 9 9 0 0 1 -1.7-.5l.8-.3c.2-.2.6-.6.8-.6h.3-1.4c-.3-.1-1-.6-1.3-.6l-.8.1s.8-.4 1.4-.5l1-.1s-.9-.3-1.1-.6l-.6-1c-.2-.1-.3-.5-.6-.5l-1 .3c-.4 0-.6-.2-.6-.6l-.1-.5c-.2-.3-.6-.8-.2-1h1.4c0-.2-.5-.6-.8-.8-.4-.2-1-.5-.7-.8l.8-.5c.2-.3.3-1 .7-.7.4.2.8 1.2 1.1 1.1.3 0 .3-.8.3-1 0-.4 0-1 .2-.9.3 0 .5.4 1 .5.4 0 1-.1 1 .2s-.3.7-.6 1-.4 1-.3 1.4c.2.5.7 1.2 1.2 1.4.4.3 1.2.5 1.7.9.5.3 1.7 1.2 2.1 1.3l.8.4s.5-.2 1.1-.2c.7 0 2.1 0 2.6-.2.6-.2 1.3-.6 1-1-.1-.6-1.3-1-1.2-1.4 0-.4.5-.4 1.2-.4.8 0 1.8.1 2-1 .2-1 .2-1.5-.8-1.8-1-.2-1.8-.2-2-1-.2-.7-.4-.9-.2-1.1.3-.2.6-.3 1.4-.4.8 0 1.6 0 1.9-.2.2-.2.3-.7.6-.9s1.4-.4 1.4-.4 1.4.7 2.7 1.7a15 15 0 0 1 2.2 2.1",
    fill: "#ed72aa",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "m228.1 226.8-.2-.6v-.3s.8 0 .7.3c0 .2-.2.2-.3.3z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "m228.1 226.8-.2-.6v-.3s.8 0 .7.3c0 .2-.2.2-.3.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "m232 225.4v-.4s.7 0 1 .3c.5.4.9 1 .9 1l-.8-.4h-.5l-.3-.1v-.3h-.3"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "m232 225.4v-.4s.7 0 1 .3c.5.4.9 1 .9 1l-.8-.4h-.5l-.3-.1v-.3h-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "m237.3 231.3-.4-.7a8 8 0 0 1 -.3-.4",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "m217.4 226.6s.5.4.8.4h.8s.2-.5.1-.8c-.2-1.2-1.2-1.4-1.2-1.4s.3.7.1 1a2 2 0 0 1 -.6.8",
    fill: "#db4446"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "m217.4 226.6s.5.4.8.4h.8s.2-.5.1-.8c-.2-1.2-1.2-1.4-1.2-1.4s.3.7.1 1a2 2 0 0 1 -.6.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "m215.2 227.6s-.4-.7-1.3-.6c-.8 0-1.4.8-1.4.8h1.2c.3.3.4 1 .4 1l.7-.6a7.2 7.2 0 0 0 .4-.6",
    fill: "#db4446"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "m215.2 227.6s-.4-.7-1.3-.6c-.8 0-1.4.8-1.4.8h1.2c.3.3.4 1 .4 1l.7-.6a7.2 7.2 0 0 0 .4-.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "m214.2 230.6s-.8.1-1.2.6-.3 1.3-.3 1.3.4-.5.9-.5l1 .2-.1-.8z",
    fill: "#db4446"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "m214.2 230.6s-.8.1-1.2.6-.3 1.3-.3 1.3.4-.5.9-.5l1 .2-.1-.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "m228.2 230.5.3-.5.3.5h-.7"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "m228.2 230.5.3-.5.3.5h-.7",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "m229 230.5.3-.5.4.5h-.8"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "m229 230.5.3-.5.4.5h-.8",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "m228.6 227.3.8.3-.7.4-.1-.6"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "m228.6 227.3.8.3-.7.4-.1-.6",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "m229.5 227.6.7.2-.5.4z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "m229.5 227.6.7.2-.5.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "m224.2 233.7s-.7.2-1 .6c-.4.5-.3 1-.3 1s.6-.5 1.5-.3l1.2.3 1.3-.3s-.7.8-.7 1.3l.2 1.1c0 .7-.6 1.6-.6 1.6l1-.3a4.6 4.6 0 0 0 1.7-.8l.9-1s-.2 1 0 1.4l.2 1.6.8-.6c.2-.1.7-.4.9-.7l.3-1s0 .8.4 1.3l.6 1.6s.3-.8.6-1.1c.3-.4.7-.8.7-1a4.3 4.3 0 0 0 -.1-.9l.4.8m-11 .6s.5-.8 1-1l1.1-.8.9-.4m1 5 1.3-.8a4 4 0 0 0 1-1",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "m216.6 240.4s-.4-.5-1.1-.3c-.7 0-1.2.9-1.2.9s.6-.2 1-.1.6.4.6.4l.4-.4.3-.6",
    fill: "#db4446"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "m216.6 240.4s-.4-.5-1.1-.3c-.7 0-1.2.9-1.2.9s.6-.2 1-.1.6.4.6.4l.4-.4.3-.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "m215.8 243.2s-.6 0-1.1.3c-.5.4-.5 1.2-.5 1.2s.4-.4.8-.3l.9.2v-.6c.2-.4-.1-.8-.1-.8",
    fill: "#db4446"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "m215.8 243.2s-.6 0-1.1.3c-.5.4-.5 1.2-.5 1.2s.4-.4.8-.3l.9.2v-.6c.2-.4-.1-.8-.1-.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "m217.2 245.8s0 .8.3 1.3c.4.5 1.1.5 1.1.5l-.3-.7c0-.4.3-.8.3-.8s-.3-.3-.7-.3z",
    fill: "#db4446"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "m217.2 245.8s0 .8.3 1.3c.4.5 1.1.5 1.1.5l-.3-.7c0-.4.3-.8.3-.8s-.3-.3-.7-.3zm16 1.3s2 1.2 1.9 2.2c0 1-1 2.3-1 2.3",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "m224.2 252.6s-.4-.6-1.1-.6-1.4.7-1.4.7.8-.1 1 .2l.5.6.5-.3z",
    fill: "#db4446"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "m224.2 252.6s-.4-.6-1.1-.6-1.4.7-1.4.7.8-.1 1 .2l.5.6.5-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "m222.2 255.3s-1-.1-1.4.3c-.4.5-.4 1.3-.4 1.3s.6-.6 1-.5c.5 0 1 .3 1 .3v-.7l-.3-.7",
    fill: "#db4446"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "m222.2 255.3s-1-.1-1.4.3c-.4.5-.4 1.3-.4 1.3s.6-.6 1-.5c.5 0 1 .3 1 .3v-.7l-.3-.7z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "m224 258.1s-.3.7 0 1.1c.3.5 1 .8 1 .8s-.3-.4-.2-.8c.1-.3.7-.8.7-.8l-1.4-.2",
    fill: "#db4446"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "m224 258.1s-.3.7 0 1.1c.3.5 1 .8 1 .8s-.3-.4-.2-.8c.1-.3.7-.8.7-.8l-1.4-.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "m236 259.3s-.8-.2-1.2 0c-.5.3-.8 1.4-.8 1.4s.7-.6 1.2-.5c.5 0 1 .3 1 .3v-.8z",
    fill: "#db4446"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "m236 259.3s-.8-.2-1.2 0c-.5.3-.8 1.4-.8 1.4s.7-.6 1.2-.5c.5 0 1 .3 1 .3v-.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "m236.4 262.2s-.6.6-.4 1.1l.6 1s0-.7.2-1l1-.3-.7-.5a15.8 15.8 0 0 1 -.7-.3",
    fill: "#db4446"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "m236.4 262.2s-.6.6-.4 1.1l.6 1s0-.7.2-1l1-.3-.7-.5a15.8 15.8 0 0 1 -.7-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "m239.4 263s-.3.8.2 1.3c.6.5 1 .5 1 .5s-.3-.7-.2-1.1c.1-.5.5-.7.5-.7l-.8-.2-.7.3",
    fill: "#db4446"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "m239.4 263s-.3.8.2 1.3c.6.5 1 .5 1 .5s-.3-.7-.2-1.1c.1-.5.5-.7.5-.7l-.8-.2-.7.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "m208.8 316.4c2 .6 3 2 3 3.8 0 2.3-2.2 4-5 4-3 0-5.3-1.7-5.3-4 0-1.7 1-3.6 3-3.8l-.2-.4-.7-.7h1.2l.8.5.5-.7c.3-.4.6-.5.6-.5l.6.6.3.5.7-.4.8-.3s0 .4-.2.7z",
    fill: "#ffd691",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "m206.3 326.7s-3.8-2.6-5.5-3c-2-.4-4.5 0-5.5 0 0 0 1.2.8 1.8 1.4.5.5 2.3 1.5 3.3 1.8 3 .8 6-.2 6-.2m1 .2s2.4-2.5 5-2.9c3-.4 5 .3 6.2.6l-1.5.8c-.5.3-2 1.5-4 1.6-2 0-4.4-.3-4.8-.2z",
    fill: "#058e6e",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "m206.7 323.8a4.8 4.8 0 0 1 0-7.1 4.8 4.8 0 0 1 1.5 3.5 4.9 4.9 0 0 1 -1.5 3.6",
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "m205.7 329s.6-1.5.6-2.7l-.1-2.1h.8s.3 1.1.3 2l-.1 2.4-.7.1z",
    fill: "#058e6e",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "m254 190.7c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "m254 190.7c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "m255.4 188.2c0-.6.5-1 1.1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "m255.4 188.2c0-.6.5-1 1.1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "m256.4 185.2c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1 -1.1-1",
    fill: "#fff"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "m256.4 185.2c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1 -1.1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "m256.5 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "m256.5 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "m255.7 179c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "m255.7 179c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "m254.1 176.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "m254.1 176.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "m252 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "m252 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "m249.4 171.8c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1",
    fill: "#fff"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "m249.4 171.8c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "m246.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "m246.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "m243.3 169.1c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "m243.3 169.1c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "m239.9 168.5c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "m239.9 168.5c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "m236.6 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "m236.6 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "m233.3 168.5c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "m233.3 168.5c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "m230.1 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1 -1.1-1",
    fill: "#fff"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "m230.1 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1 -1.1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "m231.7 171.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1m.6 3.1c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1 -1-1m0 3c0-.5.6-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1 -1-1m-1 2.8c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1 0 .6-.4 1-1 1a1 1 0 0 1 -1-1m-1.9 2.6c0-.5.5-1 1-1 .7 0 1.2.5 1.2 1s-.5 1-1.1 1-1-.4-1-1",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "m227.6 166.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "m227.6 166.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "m224.8 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "m224.8 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "m221.6 164c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.5 1-1 1-.6 0-1.1-.5-1.1-1",
    fill: "#fff"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "m221.6 164c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.5 1-1 1-.6 0-1.1-.5-1.1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "m218.3 163.4c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1 -1.1-1",
    fill: "#fff"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "m218.3 163.4c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1 -1.1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "m215 163.5c0-.6.5-1 1.1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "m215 163.5c0-.6.5-1 1.1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "m211.7 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "m211.7 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "m208.6 165.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1 -1.1-1",
    fill: "#fff"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "m208.6 165.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1 -1.1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "m156 190.7c0-.5.4-1 1-1s1 .5 1 1c0 .6-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "m156 190.7c0-.5.4-1 1-1s1 .5 1 1c0 .6-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "m154.5 188.2c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "m154.5 188.2c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "m153.5 185.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "m153.5 185.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "m153.4 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "m153.4 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "m154.2 179c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "m154.2 179c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "m155.8 176.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "m155.8 176.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "m158 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "m158 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "m160.5 171.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "m160.5 171.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "m163.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "m163.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "m166.6 169.1c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "m166.6 169.1c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "m170 168.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1",
    fill: "#fff"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "m170 168.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "m173.4 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "m173.4 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "m176.6 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1 -1.1-1",
    fill: "#fff"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "m176.6 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1 -1.1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "m179.8 168.5c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "m179.8 168.5c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "m178.2 171.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1m-.7 3.1c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1 -1-1m-.2 3c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1m.9 2.8c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1 -1.1-1m1.8 2.6c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1 -1-1",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "m182.3 166.5c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "m182.3 166.5c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "m185.2 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "m185.2 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "m188.3 164c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1 0 .5-.4 1-1 1s-1-.5-1-1",
    fill: "#fff"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "m188.3 164c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1 0 .5-.4 1-1 1s-1-.5-1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "m191.6 163.4c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "m191.6 163.4c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "m194.9 163.5c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "m194.9 163.5c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "m198.2 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "m198.2 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "m201.3 165.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1",
    fill: "#fff"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "m201.3 165.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1 -1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "m174.7 228.9h-1v-1h-1.5v3.6h1.6v2.5h-3.4v7h1.8v14.3h-3.5v7.3h27.2v-7.3h-3.5v-14.3h1.8v-7h-3.4v-2.5h1.6v-3.5h-1.6v.9h-.8v-1h-1.6v1h-1.1v-1h-1.6v3.6h1.6v2.5h-3.3v-7.8h1.7v-3.5h-1.7v.9h-1v-1h-1.5v1h-.9v-1h-1.6v3.6h1.7v7.8h-3.3v-2.5h1.6v-3.5h-1.6v.9h-.9v-1h-1.8zm-6 33.7h27.3m-27.3-1.8h27.3m-27.3-1.8h27.3m-27.3-1.7h27.3m-27.3-2h27.3m-23.8-1.6h20.2m-20.2-1.8h20.2m-20.2-2h20.2m-20.2-1.7h20.2m-20.2-1.8h20.2m-20.2-1.8h20.2m-20.2-1.7h20.2m-22-1.8h23.8m-23.8-1.8h23.8m-23.8-1.8h23.8m-23.8-1.8h23.8m-20.4-1.7h17m-10.2-1.8h3.4m-3.4-1.8h3.4m-3.4-1.8h3.4m-3.4-1.7h3.4m-5.1-2.2h6.8m-12 7.5h3.6m-5-2.2h6.6m-6.7 32.6v-1.8m0-1.8v-1.7m-1.8 1.7v1.8m3.4 0v-1.8m1.7 3.6v-1.8m0-1.8v-1.7m0-2v-1.6m0-1.8v-2m-1.7 7.4v-2m-3.4 2v-2m7 0v2m1.5-2v-1.6m-5.1-1.8v1.8m3.5-1.8v1.8m3.3-1.8v1.8m-1.6-1.7v-2m1.7-1.7v1.7m0-5.3v1.8m-1.7-3.6v1.8m1.7-3.5v1.7m-3.3-1.7v1.7m-3.5-1.7v1.7m-1.6-3.5v1.8m3.3-1.8v1.8m3.4-1.8v1.8m1.7-3.6v1.8m-3.3-1.8v1.8m-3.5-1.8v1.8m-1.6-3.6v1.8m6.7-1.8v1.8m-3.4-5.3v1.8m15.3-1.8h-3.5m5-2.2h-6.6m6.7 32.6v-1.8m0-1.8v-1.7m1.8 1.7v1.8m-3.4 0v-1.9m-1.7 3.6v-1.8m0-1.8v-1.7m0-2v-1.6m0-1.8v-2m1.7 7.4v-2m3.4 2v-2m-7 0v2m-1.5-2v-1.6m5.1-1.8v1.8m-3.5-1.8v1.8m-3.3-1.8v1.8m1.7-1.8v-2m-1.7-1.7v1.7m0-5.3v1.8m1.7-3.6v1.8m-1.7-3.5v1.7m3.3-1.7v1.7m3.5-1.7v1.7m1.6-3.5v1.8m-3.3-1.8v1.8m-3.4-1.8v1.8m-1.7-3.6v1.8m3.3-1.8v1.8m3.5-1.8v1.8m1.6-3.6v1.8m-6.7-1.8v1.8m3.4-5.3v1.8m-7 18v-2m0-5.4v-1.8m0 5.4v-1.8m0-5.3v-1.8m0-1.8v-1.7m0-3.6v-1.8m0-1.7v-1.8m-8.3 4.6h3.5m3.3-5.3h3.4m3.3 5.3h3.5",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "m186.8 262.6v-4.7c0-.8-.4-3.5-4.6-3.5-4 0-4.4 2.7-4.4 3.5v4.7z",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "m179.3 258.2-2.2-.3c0-.9.2-2.2.9-2.6l2 1.5c-.3.2-.7 1-.7 1.4zm6 0 2.2-.3c0-.9-.2-2.2-.9-2.6l-2 1.5c.3.2.7 1 .7 1.4zm-2.2-2.3 1-2a5.3 5.3 0 0 0 -2-.4l-1.7.4 1.1 2zm-4.2-5.5v-4.9c0-1.3-1-2.4-2.5-2.4s-2.4 1-2.4 2.4v4.9zm6.8 0v-4.9c0-1.3 1-2.4 2.5-2.4s2.4 1 2.4 2.4v4.9zm-1.7-12 .4-4.4h-4.2l.2 4.4zm3.3 0-.4-4.4h4.4l-.5 4.4zm-10 0 .2-4.4h-4.2l.5 4.4z",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "m185.3 262.6v-4c0-.7-.5-2.7-3.1-2.7-2.4 0-2.9 2-2.9 2.7v4zm-6.9-12.7v-4.2c0-1-.6-2.2-2-2.2s-2 1.1-2 2.2v4.3h4zm7.8 0v-4.2c0-1 .7-2.2 2-2.2s2 1.1 2 2.2v4.3h-4z",
    fill: "#0039f0"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "m190.8 269.8c0-9.7 7-17.6 15.6-17.6s15.6 7.9 15.6 17.6-7 17.5-15.6 17.5-15.6-7.8-15.6-17.5",
    fill: "#ad1519"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "m190.8 269.8c0-9.7 7-17.6 15.6-17.6s15.6 7.9 15.6 17.6-7 17.5-15.6 17.5-15.6-7.8-15.6-17.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.6
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "m195.4 269.7c0-7 5-12.8 11-12.8s11 5.7 11 12.8c0 7.2-5 13-11 13s-11-5.8-11-13",
    fill: "#005bbf"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "m195.4 269.7c0-7 5-12.8 11-12.8s11 5.7 11 12.8c0 7.2-5 13-11 13s-11-5.8-11-13z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.6
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "m201.2 260.9s-1.3 1.4-1.3 2.7a6 6 0 0 0 .6 2.4c-.2-.5-.8-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.1-.3.5-.5 1-.5s1 .4 1 1a.9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0 -1.4-1.3c-.7 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7",
    fill: "#c8b100"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "m201.2 260.9s-1.3 1.4-1.3 2.7a6 6 0 0 0 .6 2.4c-.2-.5-.8-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.1-.3.5-.5 1-.5s1 .4 1 1a.9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0 -1.4-1.3c-.7 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "m199.2 269.9h4.1v-1h-4.1z",
    fill: "#c8b100"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "m199.2 269.9h4.1v-1h-4.1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "m211.4 260.9s-1.3 1.4-1.3 2.7.6 2.4.6 2.4c-.2-.5-.7-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.2-.3.5-.5 1-.5a1 1 0 0 1 1 1 .9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.8.8 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .8.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0 -1.4-1.3c-.6 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7",
    fill: "#c8b100"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "m211.4 260.9s-1.3 1.4-1.3 2.7.6 2.4.6 2.4c-.2-.5-.7-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.2-.3.5-.5 1-.5a1 1 0 0 1 1 1 .9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.8.8 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .8.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0 -1.4-1.3c-.6 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "m209.4 269.9h4.1v-1h-4.1z",
    fill: "#c8b100"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "m209.4 269.9h4.1v-1h-4.1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "m206.3 269.6s-1.3 1.5-1.3 2.8.6 2.4.6 2.4c-.2-.5-.7-.9-1.4-.9-.8 0-1.4.6-1.4 1.4l.2.7.5 1c.1-.4.5-.6 1-.6a1 1 0 0 1 1 1 .9.9 0 0 1 0 .3h-1.2v1h1l-.8 1.5 1-.4.8.9.8-1 1 .5-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.2.9.6l.5-1 .2-.7a1.4 1.4 0 0 0 -1.4-1.4c-.7 0-1.2.4-1.4 1 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7",
    fill: "#c8b100"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "m206.3 269.6s-1.3 1.5-1.3 2.8.6 2.4.6 2.4c-.2-.5-.7-.9-1.4-.9-.8 0-1.4.6-1.4 1.4l.2.7.5 1c.1-.4.5-.6 1-.6a1 1 0 0 1 1 1 .9.9 0 0 1 0 .3h-1.2v1h1l-.8 1.5 1-.4.8.9.8-1 1 .5-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.2.9.6l.5-1 .2-.7a1.4 1.4 0 0 0 -1.4-1.4c-.7 0-1.2.4-1.4 1 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "m204.3 278.6h4.1v-1h-4.1z",
    fill: "#c8b100"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "m204.3 278.6h4.1v-1h-4.1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "m237.6 223.4h-.3a1.5 1.5 0 0 1 -.3.4c-.2.2-.6.2-.8 0a.5.5 0 0 1 -.1-.4.5.5 0 0 1 -.5 0c-.3-.1-.3-.5-.1-.7v-.5h-.3l-.1.2c-.2.3-.5.3-.7.2a.6.6 0 0 1 0-.2h-.3c-.5.2-.7-1-.7-1.2l-.2.2s.2.7.1 1.2c0 .6-.3 1.2-.3 1.2a9 9 0 0 1 2.9 1.6 9 9 0 0 1 2.2 2.3l1.2-.5c.6-.2 1.3-.2 1.3-.2l.2-.2c-.3 0-1.5.1-1.5-.4v-.2a.7.7 0 0 1 -.2 0c-.2-.2-.2-.4 0-.7l.2-.1v-.3h-.3l-.2.1c-.2.3-.6.3-.8 0a.4.4 0 0 1 -.1-.4.6.6 0 0 1 -.5 0c-.2-.2-.3-.5 0-.8l.2-.3z",
    fill: "#c8b100"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "m237.6 223.4h-.3a1.5 1.5 0 0 1 -.3.4c-.2.2-.6.2-.8 0a.5.5 0 0 1 -.1-.4.5.5 0 0 1 -.5 0c-.3-.1-.3-.5-.1-.7v-.5h-.3l-.1.2c-.2.3-.5.3-.7.2a.6.6 0 0 1 0-.2h-.3c-.5.2-.7-1-.7-1.2l-.2.2s.2.7.1 1.2c0 .6-.3 1.2-.3 1.2a9 9 0 0 1 2.9 1.6 9 9 0 0 1 2.2 2.3l1.2-.5c.6-.2 1.3-.2 1.3-.2l.2-.2c-.3 0-1.5.1-1.5-.4v-.2a.7.7 0 0 1 -.2 0c-.2-.2-.2-.4 0-.7l.2-.1v-.3h-.3l-.2.1c-.2.3-.6.3-.8 0a.4.4 0 0 1 -.1-.4.6.6 0 0 1 -.5 0c-.2-.2-.3-.5 0-.8l.2-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "m235.4 224h.2v.3h-.1c-.1 0-.1-.2 0-.2"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "m235.4 224h.2v.3h-.1c-.1 0-.1-.2 0-.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "m236.3 224.8-.3-.2v-.2h.1l.4.3.3.2v.2h-.2z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "m236.3 224.8-.3-.2v-.2h.1l.4.3.3.2v.2h-.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "m234.6 223.7-.2-.2s-.1 0 0-.1l.3.1.3.1v.2h-.1z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "m234.6 223.7-.2-.2s-.1 0 0-.1l.3.1.3.1v.2h-.1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "m233.7 223h.2v.2h-.2s-.1-.1 0-.2"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "m233.7 223h.2v.2h-.2s-.1-.1 0-.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "m237.3 225.5v-.2h-.3l.1.2z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "m237.3 225.5v-.2h-.3l.1.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "m237.9 226.2.2.2h.1c.1 0 0-.1 0-.2l-.2-.2-.2-.2h-.1v.2z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "m237.9 226.2.2.2h.1c.1 0 0-.1 0-.2l-.2-.2-.2-.2h-.1v.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "m238.8 227v-.3h-.3v.2h.3"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "m238.8 227v-.3h-.3v.2h.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "m236.2 221.1h-.6l-.1.9v.1h.2l.7-.5-.3-.5",
    fill: "#c8b100"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "m236.2 221.1h-.6l-.1.9v.1h.2l.7-.5-.3-.5",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "m234.6 221.6v.5l.9.1h.1v-.2l-.5-.7z",
    fill: "#c8b100"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "m234.6 221.6v.5l.9.1h.1v-.2l-.5-.7z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "m236.4 222.6-.4.3-.6-.7v-.1h1.1v.5",
    fill: "#c8b100"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "m236.4 222.6-.4.3-.6-.7v-.1h1.1v.5",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "m235.3 222a.3.3 0 0 1 .4 0 .3.3 0 0 1 0 .3.3.3 0 0 1 -.3 0 .3.3 0 0 1 -.1-.3",
    fill: "#c8b100"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "m235.3 222a.3.3 0 0 1 .4 0 .3.3 0 0 1 0 .3.3.3 0 0 1 -.3 0 .3.3 0 0 1 -.1-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "m233.2 221.1-.2-.7-.4-.4s.4-.2.8.1 0 .9 0 .9z",
    fill: "#c8b100"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "m233.2 221.1-.2-.7-.4-.4s.4-.2.8.1 0 .9 0 .9z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "m234.2 221.4-.4.4-.6-.6v-.2h1z",
    fill: "#c8b100"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "m234.2 221.4-.4.4-.6-.6v-.2h1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "m233.1 221 .3-.1v.3c0 .2-.1.2-.2.2l-.1-.3",
    fill: "#c8b100"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "m233.1 221 .3-.1v.3c0 .2-.1.2-.2.2l-.1-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "m238.3 222.5h-.5l-.3.7v.2h.2l.8-.4z",
    fill: "#c8b100"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "m238.3 222.5h-.5l-.3.7v.2h.2l.8-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "m236.7 222.8v.5l.8.2h.1v-.2l-.4-.7z",
    fill: "#c8b100"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "m236.7 222.8v.5l.8.2h.1v-.2l-.4-.7z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "m238.4 224-.5.2-.4-.7v-.2h.1l.9.2z",
    fill: "#c8b100"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "m238.4 224-.5.2-.4-.7v-.2h.1l.9.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "m237.3 223.2h.4a.3.3 0 0 1 0 .4.3.3 0 0 1 -.3 0 .3.3 0 0 1 0-.4",
    fill: "#c8b100"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "m237.3 223.2h.4a.3.3 0 0 1 0 .4.3.3 0 0 1 -.3 0 .3.3 0 0 1 0-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "m240.2 224.3.1.5-.8.3h-.2v-.2l.4-.8z",
    fill: "#c8b100"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "m240.2 224.3.1.5-.8.3h-.2v-.2l.4-.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "m240 225.8-.5.1-.3-.8v-.1h.2l.8.3-.1.5",
    fill: "#c8b100"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "m240 225.8-.5.1-.3-.8v-.1h.2l.8.3-.1.5",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "m238.6 224.3-.2.5.9.3h.1v-.1l-.3-.8z",
    fill: "#c8b100"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "m238.6 224.3-.2.5.9.3h.1v-.1l-.3-.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "m239.5 225.2a.3.3 0 0 0 0-.3.3.3 0 0 0 -.4 0 .3.3 0 0 0 0 .3.3.3 0 0 0 .4 0",
    fill: "#c8b100"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "m239.5 225.2a.3.3 0 0 0 0-.3.3.3 0 0 0 -.4 0 .3.3 0 0 0 0 .3.3.3 0 0 0 .4 0z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "m240.8 227h.8l.5.3s.1-.4-.3-.7c-.3-.3-.8.2-.8.2z",
    fill: "#c8b100"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "m240.8 227h.8l.5.3s.1-.4-.3-.7c-.3-.3-.8.2-.8.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "m240.3 226.1-.3.5.8.5v-.1h.2l-.1-1z",
    fill: "#c8b100"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "m240.3 226.1-.3.5.8.5v-.1h.2l-.1-1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "m241 227s.1-.1 0-.2h-.3c-.2 0-.2.1-.1.2h.3",
    fill: "#c8b100"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "m241 227s.1-.1 0-.2h-.3c-.2 0-.2.1-.1.2h.3zm38-21.9v.6h-2.4v-.6h1v-1.3h-.7v-.5h.6v-.6h.6v.6h.6v.6h-.6v1.2h1",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "m134.4 217.1v-1.2m-.4 1.2v-1.2m-.2 1.2v-1.2m-.3 1.2v-1.2",
    fill: "none"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "m133.2 217.1v-1.2m-.5 1.1v-1m.2 1v-1m-.7 1v-1m.2 1v-1m-.9 1v-1m.2 1v-1m.3 1v-1m-.7 1v-1m-.3.9v-.8m-.1.8v-.8m-.5.7v-.6m.2.6v-.6m-.4.5v-.5m-.2.5v-.4m-.3.3v-.3m-.3.3v-.2",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "m129.2 216.6v-.2",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "m135.7 217v-1m-.5 1v-1m-.4 1.2v-1.2m143 1.1v-1.1m-.4 1.1v-1.1m-.3 1.1v-1.1m-.3 1.2v-1.2",
    fill: "none"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "m276.6 217.1v-1.1m-.6 1v-1m.3 1v-1m-.8 1v-1m.3 1v-1m-.9 1v-1m.2 1v-1m.2 1v-1m-.6 1v-1m-.3.9v-.8m-.2.8v-.8m-.4.7v-.6m.2.6v-.6m-.5.6v-.6m-.2.5v-.4m-.3.4v-.4m-.2.3v-.2",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "m272.6 216.6v-.2",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "m279.1 217v-1m-.6 1v-1m-.4 1.1v-1.1",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.6eafa9c5d38a910e7ce07c9641fa158c.svg";
export { ForwardRef as ReactComponent };